// Bilingual content for Selena Service prototype
import { termsPageTranslations } from "./termsContent";

export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      services: "Servicii",
      whyUs: "De ce noi",
      rcaPartners: "Constatări daune",
      brands: "Mărci",
      paint: "Vopsitorie",
      pilkington: "Parbrize",
      climate: "Climatizare",
      claims: "Reparații daune",
      oils: "Uleiuri",
      mechanics: "Mecanică",
      diagnostics: "Diagnoză",
      itp: "ITP",
      tachograph: "Tahograf",
      booking: "Programare",
      contact: "Contact",
      bookNow: "Programează-te",
      serviceSwitcherAria: "Navigare rapidă între servicii",
      servicePrevAria: "Serviciul anterior",
      serviceNextAria: "Serviciul următor",
      breadcrumbAria: "Fil navigare",
      vinParts: "Piese după VIN",
    },
    vinPartsPage: {
      title: "Caută piese după VIN",
      subtitle:
        "Introdu VIN-ul complet (17 caractere) pentru majoritatea mărcilor — identificare orientativă prin NHTSA vPIC (SUA). Pentru BMW poți folosi și ultimele 7 caractere pentru legături către RealOEM și căutare BavAUTO după cod OE. Fără cont și fără prețuri afișate.",
      vinLabel: "VIN sau ultimele 7 caractere",
      vinPlaceholder: "ex. WBADT43452G123456 sau ultimele 7",
      searchBtn: "Caută mașina",
      disclaimer:
        "Datele sunt orientative. Verifică întotdeauna compatibilitatea piesei înainte de comandă.",
      recaptchaNotice: "Anti-abuz:",
      recaptchaPrivacy: "Confidențialitate · Google",
      recaptchaTerms: "Termeni · Google",
      recaptchaLocalhostHint:
        "reCAPTCHA pe localhost: în Google Admin (cheia site folosită aici), la „Domenii” adaugă localhost și 127.0.0.1 — sau folosește cheile de test Google pentru dev.",
      recaptchaInfoTitle: "Protecție anti-spam (Google reCAPTCHA)",
      recaptchaInfoBody:
        "Nu vei vedea o bifă sau imagini — verificarea este invizibilă și rulează automat la căutarea după VIN și la folosirea listelor de coduri OEM. Dacă apare o eroare la verificare, reîncarcă pagina și încearcă din nou.",
      recaptchaLegalLead: "Anti-abuz:",
      categoriesTitle: "Categorii piese",
      partsTitle: "Coduri OEM",
      searchProducts: "Caută produse",
      productsTitle: "Rezultate BavAUTO (fără preț)",
      loading: "Se încarcă…",
      emptyParts: "Nu am găsit coduri pentru această categorie. Încearcă altă categorie.",
      partsNhtsaNoCatalog:
        "Listele pe categorii (coduri OEM din diagrame) provin din catalogul RealOEM. Pentru vehiculul tău folosim doar date NHTSA — nu există sesiune automată de catalog, deci nu putem extrage coduri aici. Deschide un catalog în browser și caută după serial / vehicul; după ce ai un cod OEM, poți folosi căutarea de produse BavAUTO în aceeași pagină unde apare tabelul.",
      partsCatalogLinkRealoem: "RealOEM — catalog BMW (serialul tău)",
      partsCatalogLinkVpic: "NHTSA vPIC — portal oficial (SUA)",
      partsCatalogLinkEtk: "BavAUTO ETK — catalog online",
      emptyProducts: "Nu am găsit rezultate publice pentru acest cod.",
      errorGeneric: "A apărut o problemă. Încearcă din nou mai târziu.",
      back: "Înapoi la căutare",
      vehicleHeading: "Vehicul identificat",
      catBrakes: "Frâne",
      catFilters: "Filtre",
      catSuspension: "Suspensie",
      catEngine: "Motor",
      catCooling: "Răcire",
      catElectric: "Electric",
      fieldVin: "VIN (ultimele 7)",
      fieldVinFull: "VIN complet (17 caractere)",
      fieldBrand: "Marcă",
      fieldManufacturer: "Producător (Manufacturer)",
      fieldModel: "Model",
      fieldChassis: "Șasiu / serie",
      fieldEngine: "Motor",
      fieldProd: "Dată / catalog",
      fieldRecordId: "ID înregistrare",
      fieldSavedAt: "Salvat la",
      fieldEmptyValue: "—",
      vehicleDetailsSectionTitle: "Toate câmpurile raportate de sursa de decode",
      fieldSource: "Sursă",
      vehicleDecodeSourceLabel: "Identificare automată",
      vehicleNhtsaName: "NHTSA vPIC",
      vehicleCatalogManualLabel: "Catalog OEM cu diagrame (manual)",
      vehicleNhtsaNote:
        "Datele afișate sunt orientative (piața SUA). Nu înlocuiesc catalogul producătorului pentru compatibilitatea pieselor.",
      diagramLink: "Diagramă",
    },
    notFound: {
      eyebrow: "404",
      title: "Pagina nu există",
      lead:
        "Adresa pe care ai ajuns nu corespunde unei pagini disponibile pe site. Verifică ortografia sau folosește meniul pentru serviciile noastre.",
      pathLabel: "Adresa:",
      hint: "Dacă ai ajuns aici din greșeală, te ajutăm cu plăcere la telefon.",
      backHome: "Înapoi la pagina principală",
      callUs: "Sună-ne",
      homeHref: "/",
      phoneHref: "tel:+40343101131",
    },
    appPortal: {
      metaTitle: "Autentificare · Admin sau recepție | Selena Service",
      metaDescription:
        "Acces la panoul de administrare sau la portalul recepție și atelier (echipă Selena Service).",
      eyebrow: "Acces echipă",
      title: "Unde vrei să intri?",
      subtitle: "Alege portalul potrivit; te ducem la pagina de autentificare.",
      adminBtn: "Administrator",
      adminHint: "Rapoarte, setări, utilizatori portal",
      deskBtn: "Recepție / atelier",
      deskHint: "Programări, agendă, fișe",
      backSite: "Înapoi la site-ul public",
    },
    hero: {
      eyebrow: "Service Auto Multimarcă · Slobozia · Ialomița",
      title1: "Selena",
      title2: "Service",
      lead:
        "Reparator multimarcă din 2014. ITP, mecanică, caroserie, parbrize Pilkington și constatări daune — soluții la cheie, pentru orice buzunar.",
      ctaPrimary: "Programează-te acum",
      ctaSecondary: "Vezi serviciile",
      stat1: "12+",
      stat1Label: "Ani de experiență",
      stat2: "22",
      stat2Label: "Mărci deservite",
      stat3: "10",
      stat3Label: "Asiguratori parteneri",
      stat4: "100%",
      stat4Label: "Echipamente moderne",
      photoBadge: "Reparator multimarcă · Din 2014",
    },
    services: {
      eyebrow: "01 — Servicii",
      title: "Tot ce are nevoie mașina ta",
      detailsCta: "Vezi detalii",
      subtitle:
        "De la inspecția tehnică periodică la reparații complexe de caroserie. Echipamente moderne, piese originale, garanție pentru lucrare.",
      items: [
        {
          code: "S/01",
          title: "Mecanică & Revizii",
          desc:
            "Revizii periodice, întreținere, reparații mecanice complete, multimarcă. Piese originale și echivalente OEM.",
        },
        {
          code: "S/02",
          title: "Diagnoză computerizată",
          desc:
            "Diagnoză multimarcă cu testere de ultimă generație. Identificăm rapid orice defect electronic sau mecanic.",
        },
        {
          code: "S/03",
          title: "Tinichigerie & Vopsitorie",
          desc:
            "Reparații caroserie, vopsitorie în cabină, finisaje profesionale. Birou constatări daune dedicat.",
        },
        {
          code: "S/04",
          title: "Parbrize Pilkington",
          desc:
            "Membri rețeaua națională Pilkington Centru de Parbrize. Înlocuiri și reparații lovituri de piatră.",
        },
        {
          code: "S/05",
          title: "Climatizare auto",
          desc:
            "Încărcare freon auto (R134a / R1234yf), verificare etanșeitate, presiuni și diagnostic A/C în Slobozia. Opțional substanță contrast UV.",
        },
        {
          code: "S/06",
          title: "Constatări daune",
          desc:
            "Parteneri asigurători RCA (autorizați ASF). Birou daune dedicat în service.",
        },
        {
          code: "S/07",
          title: "Uleiuri & consultanță",
          desc:
            "Te ajutăm să alegi uleiul potrivit. Cel mai bun nu este neapărat și cel mai scump.",
        },
        {
          code: "S/08",
          title: "ITP Auto & Camioane",
          desc:
            "Linie ITP nouă, intrare/ieșire separate, echipamente de ultimă generație pentru autovehicule și camioane.",
        },
        {
          code: "S/09",
          title: "Verificare Tahograf",
          desc:
            "Verificare periodică tahografe digitale pentru flote comerciale, autorizați RAR. Termen maxim 2 ani.",
        },
      ],
    },
    mechanicsPage: {
      eyebrow: "Serviciu dedicat",
      title: "Service mecanică auto și revizii în Slobozia — multimarcă",
      lead:
        "Întreținere periodică și reparații mecanice pentru autoturisme și vehicule utilitare: motor, frânare, direcție, suspensie, transmisie și sisteme auxiliare. Lucrăm transparent, cu recomandări clare înainte de montaj.",
      secondary:
        "Mulți clienți caută «revizie auto», «schimb ulei și filtre», «probleme la frână» sau «zgomote suspensie». În Ialomița, din Slobozia, poți programa revizii și intervenții punctuale sau complete — folosim piese originale sau echivalente OEM, în funcție de specificația mașinii și buget.",
      heroImageAlt:
        "Revizii auto, mecanică multimarcă și reparații în service Selena Service Slobozia, județul Ialomița",
      cardsSectionTitle: "Revizii, reparații și piese potrivite pentru mașina ta",
      card1Title: "Revizii și întreținere planificată",
      card1Text:
        "Schimb ulei și filtre (motor, aer, combustibil, cabină unde e cazul), verificări pe puncte critice și înlocuiri preventive conform uzurii — cu istoric și recomandări pentru următorii kilometri.",
      card2Title: "Reparații mecanice complete",
      card2Text:
        "Diagnosticăm și remediem defecțiuni la sistemul de frânare, direcție, suspensie, ambreiaj, kit distribuție (unde e aplicabil), transmisie și motor — lucrări explicate înainte de execuție.",
      card3Title: "Piese originale și echivalente OEM",
      card3Text:
        "Propunem variante compatibile cu cerințele producătorului: piese originale sau echivalente certificate, astfel încât garanția lucrării și fiabilitatea să rămână la standard.",
      faqTitle: "Întrebări frecvente: revizie auto și mecanică în Slobozia",
      faq: [
        {
          q: "Ce include o revizie periodică la un service multimarcă?",
          a:
            "În funcție de marcă, kilometraj și istoricul mașinii, revizia poate include schimbul de ulei și filtre, verificarea nivelurilor, vizual inspecție frână, direcție și suspensie, plus înlocuiri preventive recomandate de producător. Îți comunicăm lista lucrărilor și costurile înainte de începerea lucrului.",
        },
        {
          q: "Folosiți piese originale sau aftermarket?",
          a:
            "Oferim opțiuni transparente: piese originale sau echivalente OEM conform specificației mașinii. Alegerea depinde de cerințele tehnice și de buget — îți explicăm diferențele pentru fiecare poziție importantă.",
        },
        {
          q: "Pot veni doar pentru diagnoză înainte de reparație?",
          a:
            "Da. Poți programa mai întâi diagnoza computerizată sau verificarea mecanică detaliată; stabilim împreună pașii următori după ce avem simptome clare și date din tester.",
        },
        {
          q: "Unde este service-ul și cum mă programez?",
          a:
            "Suntem în Slobozia, str. General Magheru nr. 73, județul Ialomița. Folosește formularul de programare de pe site pentru mecanică și revizii — te sunăm pentru confirmare.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare mecanică / revizie",
        title: "Solicită revizie sau reparație mecanică auto",
        lead:
          "Completează formularul pentru revizie, schimb ulei sau reparație mecanică — revenim rapid pentru confirmare și interval.",
      },
    },
    diagnosticsPage: {
      eyebrow: "Serviciu dedicat",
      title: "Diagnoză computerizată auto multimarcă în Slobozia",
      lead:
        "Tester profesionist pentru citire coduri eroare (DTC), parametri în timp real și verificări ghidate — pentru mașini cu electronics ADAS, ECU și sisteme moderne de propulsie.",
      secondary:
        "Dacă luminează martorul în bord (check engine), ai pierderi de putere sau consum anormal, diagnoza computerizată ajută să izolăm cauza înainte de a înlocui piese la întâmplare. În Selena Service combinăm datele din tester cu verificarea practică în service.",
      heroImageAlt:
        "Diagnoză computerizată multimarcă și interpretare coduri eroare la Selena Service Slobozia",
      cardsSectionTitle: "Scanare, interpretare și plan clar de remediere",
      card1Title: "Citire coduri și parametri live",
      card1Text:
        "Accesăm modulele relevante (motor, transmisie, ABS/ESP unde e cazul), înregistrăm parametri și istoric defecte pentru o imagine completă.",
      card2Title: "Legătură între cod și simptom",
      card2Text:
        "Un cod nu înseamnă automat «schimbă senzorul». Corelăm mesajele din ECU cu comportamentul mașinii și cu verificările mecanice/electrice necesare.",
      card3Title: "Recomandări prioritizate și costuri estimate",
      card3Text:
        "Îți prezentăm ce este urgent pentru siguranță, ce poate fi planificat și ce variante de reparație există — înainte să aprobi lucrarea.",
      faqTitle: "Întrebări frecvente despre diagnoza auto computerizată",
      faq: [
        {
          q: "Când am nevoie de diagnoză computerizată?",
          a:
            "Este utilă la martori aprinși în bord, pierderi de putere, porniri atipice, consum crescut sau după evenimente electrice. Este și un pas bun înaintea unei reparații mai mari pentru a nu înlocui componente inutile.",
        },
        {
          q: "Înlocuiește testerul verificarea mecanică clasică?",
          a:
            "Nu. Testerul indică direcția și poate accelera diagnosticul, dar confirmarea în teren (presiuni, etanșeitate, vizual, probe de drum unde e sigur) rămâne esențială pentru concluzii corecte.",
        },
        {
          q: "Lucrați pe mai multe mărci?",
          a:
            "Da — suntem service multimarcă. Complexitatea diferă după marcă și generație; îți spunem din start ce nivel de acces și investigație este rezonabil pentru cazul tău.",
        },
        {
          q: "Cum mă programez pentru diagnoză?",
          a:
            "Folosește formularul de pe această pagină și selectează serviciul de diagnoză — te contactăm pentru confirmare și interval.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare diagnoză ECU",
        title: "Solicită diagnoză computerizată multimarcă",
        lead:
          "Programează citire coduri și interpretare tester — revenim rapid pentru confirmare și interval în Slobozia.",
      },
    },
    climatePage: {
      eyebrow: "Serviciu dedicat",
      title: "Climatizare auto și încărcare freon R134a / R1234yf în Slobozia",
      lead:
        "Întreținem instalația de climatizare pentru confort sigur în orice sezon: răcire vara, dezaburire iarna. Folosim exclusiv agent frigorific auto omologat — freon auto R134a sau R1234yf (denumire tehnică R1234YF) — în funcție de anul de fabricație și eticheta service a mașinii tale.",
      secondary:
        "Când aerul nu mai răcește suficient, simți miros în habitaclu sau auzi compresorul turat fără efect, este posibil să fie nevoie de completare freon (reîncărcare agent frigorific), verificare pierderi sau curățare circuit. Evaluăm presiunile, propunem test de etanșeitate acolo unde e cazul și îți explicăm înainte de intervenție dacă ajunge o completare, un ciclu cu vidare sau este nevoie de reparație.",
      heroImageAlt:
        "Încărcare freon auto R134a și R1234yf, climatizare și verificare A/C la Selena Service Slobozia, Ialomița",
      cardsSectionTitle: "Ce presupune serviciul pentru freon și climatizare",
      card1Title: "Tipul corect de freon (R134a sau R1234yf)",
      card1Text:
        "Nu «universal». Reîncărcăm doar cu freon auto potrivit mașinii: R134a pentru instalațiile clasice sau R1234yf (HFO) pentru vehiculele noi — respectăm etichetele service și recomandările constructorului.",
      card2Title: "Presiuni, etanșeitate și circuit",
      card2Text:
        "Măsurăm presiunile de lucru, verificăm funcționarea compresorului și condensatorului și căutăm pierderi de agent. La nevoie putem folosi substanță de contrast (UV) pentru scurgeri fine, ca să nu plătești freon în straturi peste o problemă reală.",
      card3Title: "Recomandări transparente",
      card3Text:
        "Primești diagnostic clar și costuri înainte de lucru: întreținere, încărcare freon auto, vidare/evacuare conform procedurii sau reparație (ex. garnituri, schimb componentă) — fără lucrări inutile.",
      faqTitle: "Întrebări frecvente: freon auto, R134a și R1234yf",
      faq: [
        {
          q: "Ce înseamnă încărcare freon auto și când este necesară?",
          a:
            "Prin încărcare (sau completare) freon înțelegem adăugarea de agent frigorific omologat în instalația de climatizare, după verificarea stării sistemului. Este indicată frecvent când aerul nu mai răcește bine, există pierderi în timp sau după lucrări la circuitul de climatizare. La noi în Slobozia verificăm mai întâi presiunile și etanșeitatea, apoi propunem soluția potrivită.",
        },
        {
          q: "Care este diferența între freon auto R134a și R1234yf (R1234YF)?",
          a:
            "R134a a fost standardul mulți ani pentru instalațiile cu conexiuni de serviciu specifice. R1234yf este agentul folosit pe tot mai multe autoturisme noi, cu cerințe de mediu diferite. Nu sunt interschimbabile «după ureche»: tipul corect este dictat de constructor și de construcția instalației. Folosim doar agentul potrivit mașinii tale.",
        },
        {
          q: "De ce nu este suficient să «tragă cineva doar puțin freon»?",
          a:
            "O pierdere repetată sau un nivel greșit poate deteriora compresorul și poate ascunde scurgeri la furtunuri, radiator climă sau garnituri. De aceea combinăm completarea cu verificarea circuitului și, dacă e nevoie, cu căutarea scurgerilor — astfel îți menții eficiența și durabilitatea instalației.",
        },
        {
          q: "În ce zonă lucrați și cum mă programez?",
          a:
            "Service-ul nostru este în Slobozia, județul Ialomița. Poți solicita programare online din această pagină pentru climatizare și încărcare freon auto; te sunăm pentru confirmare și interval.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare climatizare / freon",
        title: "Solicită încărcare freon sau service climatizare auto",
        lead:
          "Completează formularul pentru climatizare auto sau încărcare freon R134a / R1234yf — revenim rapid pentru confirmare la telefon.",
      },
    },
    oilsPage: {
      eyebrow: "Serviciu dedicat",
      title: "Schimb ulei motor, consultanță și specificație corectă — Slobozia",
      lead:
        "Te ghidăm să alegi uleiul potrivit pentru motorul tău (benzină, diesel, eco), după specificația producătorului — SAE, API, ACEA și cerințe OEM. Cel mai bun ulei nu este mereu cel mai scump.",
      secondary:
        "Pentru schimb ulei și filtre în Slobozia folosim cantitatea și specificația corectă; îți explicăm pe scurt ce înseamnă etichetele de pe bidon și cum verifici nivelul între revizii. Mai jos găsești și selectoare oficiale ale marilor producători pentru verificare rapidă.",
      heroImageAlt:
        "Consultanță ulei motor, standarde SAE/API/ACEA și schimb ulei în service Selena Service Slobozia",
      standardsTitle: "Standardele în industria uleiurilor auto",
      standardsLead:
        "Standardele principale folosite pentru alegerea uleiului sunt stabilite de SAE, API și ACEA. Ele te ajută să alegi vâscozitatea corectă, nivelul de performanță și compatibilitatea cu tipul de motor.",
      standardsImageAlt: "Clasificarea SAE a vâscozității uleiurilor în funcție de temperatură",
      apiImageAlt: "Clasificare internațională API pentru motoare diesel și benzină",
      saeTitle: "SAE - Vâscozitate",
      saePoints: [
        "Primul număr (ex: 5W) arată comportamentul la rece; cu cât este mai mic, cu atât pornirea la rece este mai bună.",
        "Litera W vine de la winter (iarnă) și indică performanța uleiului la temperaturi scăzute.",
        "Al doilea număr (ex: 30, 40) arată comportamentul la cald și protecția la temperaturi ridicate.",
      ],
      apiTitle: "API - Nivel de performanță",
      apiPoints: [
        "Pentru motoare pe benzină se folosesc clasele care încep cu S.",
        "Pentru motoare diesel se folosesc clasele care încep cu C.",
        "A doua literă indică nivelul de performanță; o literă mai avansată în alfabet indică standard mai nou.",
      ],
      aceaTitle: "ACEA - Tip aplicație",
      aceaPoints: [
        "A/B: motoare benzină și diesel de autoturisme și vehicule ușoare.",
        "C: motoare compatibile cu sisteme de post-tratare (ex: filtre de particule).",
        "E: motoare diesel de mare putere pentru aplicații comerciale.",
      ],
      selectorTitle: "Identificare ulei - linkuri actualizate",
      selectorLead:
        "Mai jos ai selectoare oficiale de la producători mari, utile pentru identificarea specificației potrivite în funcție de mașină și motor.",
      selectorLinks: [
        { name: "Castrol", url: "https://www.castrol.com/en_us/united-states/home/motor-oil-and-fluids/motor-oil-and-fluids-finder.html?customerType=retail" },
        { name: "Valvoline", url: "https://www.valvolineglobal.com/en/product-finder/" },
        { name: "Repsol", url: "https://lubricants.repsol.com/en/products/lubricants-search-engine/" },
        { name: "Mobil", url: "https://www.mobil.co.uk/en-gb/product-selector/" },
        { name: "LIQUI MOLY", url: "https://www.liqui-moly.com/en/us/service/oil-guide.html" },
      ],
      cardsSectionTitle: "Consultanță practică înainte de schimbul de ulei",
      card1Title: "Specificație conform manualului și OEM",
      card1Text:
        "Verificăm cerințele producătorului (SAE/API/ACEA și approvals dedicate). Nu recomandăm «oricare ulei ieftin» dacă îți compromite protecția motorului sau sistemele de post-tratare.",
      card2Title: "Nivel corect și interval de schimb",
      card2Text:
        "Îți arătăm cum verifici nivelul în siguranță și ce înseamnă consum normal versus pierderi — lipsa de ulei deterioră rapid motorul.",
      card3Title: "Schimb complet: ulei și filtru",
      card3Text:
        "Schimbăm filtrul de ulei acolo unde este recomandat odată cu uleiul, umplem cantitatea corectă și notăm tipul folosit pentru istoric.",
      faqTitle: "Întrebări frecvente: ulei motor și schimb ulei auto",
      faq: [
        {
          q: "Cum aflu ce ulei trebuie la mașina mea?",
          a:
            "Caută în manualul mașinii sau pe capacul motorului specificația SAE și cerințele API/ACEA/OEM. În service folosim aceste informații și, la nevoie, selectoarele producătorilor de lubrifianți pentru confirmare.",
        },
        {
          q: "Ce înseamnă notarea 5W-30 sau 5W-40?",
          a:
            "Primul număr cu W indică fluiditatea la rece; al doilea număr indică comportamentul la temperaturi înalte de exploatare. Alegerea corectă depinde de motor, climă și recomandarea producătorului.",
        },
        {
          q: "Este recomandat să amestec uleiuri diferite?",
          a:
            "Evită amestecul între tipuri diferite sau între specificații incompatibile. Dacă trebuie completat urgent, folosește aceeași specificație sau cere sfat înainte.",
        },
        {
          q: "Pot programa schimb ulei și consultanță în Slobozia?",
          a:
            "Da — folosește formularul de programare pentru «Uleiuri & consultanță» și te sunăm pentru confirmare și interval.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare schimb ulei",
        title: "Solicită consultanță sau schimb ulei și filtre",
        lead:
          "Completează formularul pentru schimb ulei, filtre sau sfat privind specificația potrivită — revenim rapid pentru confirmare.",
      },
    },
    paintPage: {
      eyebrow: "Serviciu dedicat",
      title: "Vopsitorie auto și tinichigerie în cabină — Slobozia",
      lead:
        "Vopsitorie profesională pentru elemente caroserie sau intervenții locale: stratificație corectă, culoare și lac pentru rezistență la factori exteriori și uzura zilnică.",
      leadExtended:
        "Pregătirea autovehiculului pentru vopsire se face în stații speciale, cu filtrare și uscarea aerului. Izolarea zonelor de lucru este completă, indiferent de numărul elementelor vopsite, pentru a evita depunerile de impurități și diferențele de nuanță.",
      secondary:
        "Mulți clienți caută «vopsitorie auto după accident», «retuș», «schimbă element» sau «egalare nuanță». În Selena Service combinăm tinichigerie și vopsire în cabină dedicată cu proces controlat — evaluăm suprafața, îți propunem pașii și materialele înainte de execuție.",
      heroImageAlt: "Vopsitorie auto profesională în cabină și tinichigerie la Selena Service Slobozia",
      cardsSectionTitle: "De ce contează cabină de vopsire și pregătirea corectă",
      card1Title: "Pregătire și dedusting în zonă dedicată",
      card1Text:
        "Curățare, șlefuire și mascare strictă pentru margini precise — aer filtrat pentru a reduce praful ce poate compromite stratul final.",
      card2Title: "Izolare și uniformitate cromatică",
      card2Text:
        "Lucrăm etapizat pentru egalarea nuanței și pentru tranziții corecte între zone vopsite și nerămase — esențial la intervenții parțiale.",
      card3Title: "Uscare și temperatură în cabină",
      card3Text:
        "Stratificarea și timpii de uscare sunt respectate pentru aderență și luciu stabil — rezultate mai predictibile în orice sezon.",
      processTitle: "Cum lucrăm în vopsitorie",
      processSteps: [
        "Evaluăm starea suprafeței și stabilim tipul de intervenție: locală, parțială sau completă.",
        "Pregătim suprafața prin curățare, șlefuire și mascarea zonelor care nu trebuie vopsite.",
        "Aplicăm vopseaua în cabină dedicată, cu control al ventilației și al temperaturii.",
        "Uscarea se face controlat, urmată de verificare finală și, unde este necesar, polish de finisare.",
      ],
      qualityTitle: "Calitate materiale și durabilitate",
      qualityText:
        "Urmează recomandările tehnice pentru materiale, diluanți și timpi de lucru — astfel stratul final are aderență bună, culoare uniformă și rezistență în exploatare.",
      faqTitle: "Întrebări frecvente: vopsitorie auto și cabină",
      faq: [
        {
          q: "Ce este cabină de vopsitorie și de ce contează?",
          a:
            "Este un spațiu ventilat și filtrat unde se aplică vopseaua și lacul în condiții controlate — mai puține impurități, strat mai uniform și mai puține «pori» vizibili în lumină.",
        },
        {
          q: "Pot vopsi doar o parte din mașină fără diferență vizibilă?",
          a:
            "Depinde de vechimea vopselei, nuanță și tip de intervenție. Pentru zone parțiale folosim tehnici de egalare și blend — îți spunem din evaluare ce rezultat este realist.",
        },
        {
          q: "Cât durează uscarea și când pot folosi mașina?",
          a:
            "Durata depinde de materiale, număr de straturi și temperatura mediului. Îți comunicăm timpul recomandat înainte de predare pentru a nu compromite lacul.",
        },
        {
          q: "Cum solicit evaluare pentru vopsitorie?",
          a:
            "Programează-te din formularul de pe această pagină — preferabil cu fotografii și descrierea zonei afectate; te sunăm pentru interval și pași.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare tinichigerie / vopsitorie",
        title: "Solicită evaluare pentru vopsitorie auto",
        lead:
          "Cerere online pentru evaluare vopsitorie sau tinichigerie — revenim rapid pentru confirmare și vizionare în service.",
      },
    },
    itpPage: {
      eyebrow: "Serviciu dedicat",
      title: "ITP auto și camioane în Slobozia — stație RAR autorizată",
      lead:
        "Inspecție tehnică periodică (ITP) pentru autoturisme și vehicule grele pe linie modernă: flux organizat, intrare și ieșire separate și verificări conform legislației în vigoare.",
      secondary:
        "Dacă cauți «ITP Slobozia», «statie ITP camioane» sau «programare ITP», poți cere interval online — îți confirmăm telefonic documentele necesare și durata estimată în funcție de categoria vehiculului.",
      heroImageAlt:
        "Stație ITP pentru autoturisme și camioane la Selena Service Slobozia, județul Ialomița",
      cardsSectionTitle: "Verificări conforme și flux eficient pentru ITP",
      card1Title: "Norme și puncte obligatorii",
      card1Text:
        "Parcurgem punctele cerute pentru categoria vehiculului — cu accent pe siguranța rutieră și conformitate formă.",
      card2Title: "Autoturisme și vehicule comerciale",
      card2Text:
        "Echipamente pentru categorii diferite (inclusiv tonaj mare); organizăm receptarea astfel încât să reducem timpul pierdut în service.",
      card3Title: "Organizare și program",
      card3Text:
        "Intrări și ieșiri stabilite pentru claritate în ziua vizitei — folosiți programarea online pentru rezervare inițială.",
      faqTitle: "Întrebări frecvente despre ITP la Slobozia",
      faq: [
        {
          q: "Ce este ITP-ul și la ce interval se face?",
          a:
            "ITP (Inspecția Tehnică Periodică) verifică starea tehnică a vehiculului pentru circulație sigură. Intervalele și documentele pot varia după categorie și utilizare — îți spunem clar ce te privește în funcție de mașina ta.",
        },
        {
          q: "Faceți ITP pentru camioane și vehicule utilitare grele?",
          a:
            "Da — avem infrastructură pentru autoturisme și pentru vehicule comerciale; confirmăm disponibilitatea și intervalul după înscrierea în formular.",
        },
        {
          q: "Ce documente sunt utile în ziua ITP?",
          a:
            "În general cartea mașinii, CI și asigurare RCA valabilă pentru probele necesare inspecției; dacă lipsesc elemente, te ghidăm înainte de vizită.",
        },
        {
          q: "Cum mă programez?",
          a:
            "Completează formularul pentru «ITP Auto & Camioane» — te sunăm pentru confirmare și ora recomandată.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare ITP Slobozia",
        title: "Solicită interval pentru ITP auto sau camion",
        lead:
          "Cerere online pentru ITP — revenim rapid pentru confirmare, documente necesare și flux în ziua vizitei.",
      },
    },
    tachographPage: {
      eyebrow: "Serviciu dedicat",
      title: "Verificare tahograf digital — camioane și flote în Ialomița",
      lead:
        "Verificări periodice pentru tahografe digitale conform cerințelor legale și pentru continuitatea activității transportului rutier — punct de lucru autorizat în rețeaua practicienilor verificători.",
      secondary:
        "Flotele și operatorii caută des «verificare tahograf», «periodicitate tahograf» sau «programare tahograf». În Slobozia poți programa sesiunea online; îți comunicăm ce documente pregătesc și cum pregătim vehiculul pentru stație.",
      cardsSectionTitle: "Control tehnic, intervale și conformitate operațională",
      card1Title: "Verificare tehnică și înregistrări",
      card1Text:
        "Testăm funcționarea tahografului și modul în care sunt înregistrate datele relevante pentru conformitate și audit.",
      card2Title: "Menținerea intervalului legal",
      card2Text:
        "Îți reamintim periodicitatea recomandată și îți propunem slot-uri pentru a evita întreruperi în exploatare și amenzi pentru întârzieri.",
      card3Title: "Comunicare clară către firmă",
      card3Text:
        "Primești rezumatul rezultatelor și pașii următori pentru dosarul firmei și pentru mentenanța altor vehicole din flotă.",
      faqTitle: "Întrebări frecvente: tahograf digital și verificări",
      faq: [
        {
          q: "Ce este verificarea periodică tahograf?",
          a:
            "Este verificarea tehnică obligatorie pentru tahografe digitale instalate la vehiculele care intră sub incidenta legislației transportului — documentăm rezultatul pentru conformitate.",
        },
        {
          q: "Cine poate solicita verificarea?",
          a:
            "În general operatorii de transport și deținătorii flotelor; pentru programări individuale confirmăm cerințele după tipul vehiculului și uz comercial.",
        },
        {
          q: "Pot programa pentru mai multe vehicole?",
          a:
            "Da — notează în mesaj numărul de unități și intervalul dorit; revenim cu propunere de planificare.",
        },
        {
          q: "Cum încep programarea la Selena Service?",
          a:
            "Folosește formularul «Verificare Tahograf» și lasă date firmă / camion — te sunăm pentru confirmare.",
        },
      ],
      bookingCopy: {
        eyebrow: "Programare tahograf digital",
        title: "Solicită verificarea tahografului pentru camion sau flotă",
        lead:
          "Cerere online pentru tahograf digital — confirmăm telefonic intervalul și documentele necesare.",
      },
    },
    claimsPage: {
      eyebrow: "Centru constatări daune RCA",
      title: "Constatări daune auto RCA și CASCO — birou în Selena Service Slobozia",
      tagline:
        "Ai fost într-un accident și cealaltă parte are RCA la una dintre societățile cu care lucrăm? Nu-ți face griji — te ghidăm pas cu pas.",
      lead:
        "În aceeași locație cu service-ul clarificăm pașii pentru avizare și dosar, îți spunem ce documente să pregătești și menținem legătura cu compania RCA — apoi poți continua cu evaluarea detaliată și reparația multimarcă în Selena Service.",
      secondary:
        "Reduci drumurile și întrebările: același punct de lucru pentru biroul de daune și pentru continuarea lucrărilor după acceptările din dosar.",
      cardsSectionTitle: "Deschidere dosar, claritate și reparație în același loc",
      card1Title: "Prim pas — aviz și documente",
      card1Text:
        "Îți explicăm ce înseamnă avizarea daunei și pregătim lista de acte (CIV, talon, permis, copii RCA, Constatare amiabilă sau proces-verbal etc., după caz). Fotografiem și notăm vizibil zona avariată pentru dosar.",
      card2Title: "Legătura cu asiguratorul RCA",
      card2Text:
        "Lucrăm cu societăți RCA autorizate ASF — lista este mai jos. Urmezi pașii și mesajele cerute de compania vinovatului; te ajutăm să nu pierzi cerințe sau termene procedurale obișnuite.",
      card3Title: "Constatare și reparație",
      card3Text:
        "După ce dosarul este în lucru și există acceptarea lucrărilor, inspectorul agreat și echipa noastră pot continua cu expertiza și tinichigeria în aceeași unitate.",
      faqTitle: "Întrebări frecvente — dosar RCA și constatări",
      faq: [
        {
          q: "Ce este constatarea inițială la biroul din service?",
          a:
            "Este primul pas după accident: documentăm vizibil prejudiciul (inclusiv fotografii), clarificăm ce urmează în dosar și ce transmite societatea RCA.",
        },
        {
          q: "Aveți birou daune fizic în service?",
          a:
            "Da — în Selena Service poți cere programare pentru evaluare și suport inițial pentru dosar.",
        },
        {
          q: "Cu ce asigurători lucrați?",
          a:
            "Colaborăm cu companiile RCA din lista ASF afișată mai jos — verifică dacă RCA vinovatului este în listă și întreabă-ne pentru pașii specifici.",
        },
        {
          q: "Pot programa online?",
          a:
            "Da — folosește formularul pentru «Constatări daune» și menționează compania RCA dacă o știi deja.",
        },
        {
          q: "Ce acte sunt în general necesare pentru dosar?",
          a:
            "De regulă: act și permis pentru conducătorii implicați; documentele mașinilor (CIV, talon); copii ale polițelor RCA; în original Constatarea amiabilă completată sau proces-verbal de la poliție; fotografii de la locul faptei; împuterniciri dacă dosarul nu îl deschide persoana fizică titulară sau pentru persoane juridice. Lista exactă poate varia după tipul accidentului și cerințele societății — o adaptăm împreună la telefon sau la vizită.",
        },
        {
          q: "Cât de repede trebuie anunțată dauna?",
          a:
            "În practică se recomandă notificarea foarte rapidă — des orientativ în primele 24–48 de ore pentru accidente ușoare. Confirmă mereu și în condițiile din polița RCA și ghidul companiei.",
        },
        {
          q: "Ce urmează după deschiderea dosarului?",
          a:
            "Asiguratorul are proceduri și termene proprii pentru analiză și răspuns. După ce lucrările sunt acceptate în dosar, stabilim împreună evaluarea detaliată și intrarea în reparație în service.",
        },
      ],
      partnersTitle: "Parteneri asigurători RCA (autorizați ASF)",
      disclaimer:
        "Denumiri comerciale și logo-uri aparțin societăților respective și sunt folosite pentru identificare. Nu suntem sucursala sau reprezentanța oficială a asiguratorilor listați; serviciile noastre complementează, nu înlocuiesc obligațiile legale sau contractuale ale acestora.",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
      bookingCopy: {
        eyebrow: "Programare birou daune",
        title: "Solicită evaluare pentru dosar daune RCA/CASCO",
        lead:
          "Mesaj online pentru constatare inițială — revenim pentru confirmare și lista documentelor necesare.",
      },
    },
    why: {
      eyebrow: "02 — De ce Selena",
      title: "Garanție prin fapte, nu prin promisiuni",
      lead:
        "Suntem reparator multimarcă în județul Ialomița din 2014. Lucrăm direct cu producători și asiguratori. Calitate auditabilă, transparență totală.",
      pilkington: {
        eyebrow: "Partener oficial",
        title: "Centru de Parbrize - Pilkington Team Partner",
        lead:
          "Din august 2021, Selena Service face parte din rețeaua națională Pilkington Centru de Parbrize pentru montaj și înlocuire geamuri auto.",
        cta: "Vezi pagina dedicată",
        details: [
          "Pilkington Automotive Romania este lider pe piața parbrizelor și operează o rețea națională de parteneri.",
          "Parbrizul este element structural de siguranță, iar lucrările se fac după standarde de calitate și montaj controlat.",
          "Sunt disponibile soluții de decontare directă pentru clienții cu polițe CASCO, plus suport pentru flote.",
        ],
        image: "/resources/pilkington-team-partner.png",
        imageAlt: "Centru de Parbrize Pilkington Team Partner",
      },
      bullets: [
        "Reparator multimarcă autorizat",
        "Partener Pilkington — Centru de Parbrize",
        "Echipamente ITP de ultimă generație",
        "Hală nouă, intrare și ieșire separate",
        "Birou constatări daune în incintă",
        "Soluții la cheie pentru flote comerciale",
      ],
    },
    insurerPartnersHome: {
      eyebrow: "03 — Constatări daune",
      title: "Constatări daune RCA/CASCO — asigurători parteneri ASF, aceeași locație pentru dosar și reparație",
      lead:
        "Dacă RCA vinovatului este la unul dintre acești asigurători, te ajutăm cu orientarea după accident (documente, avizare) și cu continuarea lucrărililor după acceptările din dosar — biroul de daune funcționează în incinta Selena Service.",
      disclaimer:
        "Denumiri comerciale și logo-uri aparțin societăților respective și sunt folosite pentru identificare. Nu suntem sucursala sau reprezentanța oficială a asiguratorilor listați; serviciile noastre complementează, nu înlocuiesc obligațiile legale sau contractuale ale acestora.",
      cta: "Detalii: constatări daune și birou dosare",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
    },
    brands: {
      eyebrow: "04 — Mărci deservite",
      title: "Lucrăm cu orice marcă",
    },
    reviews: {
      eyebrow: "Recenzii Google",
      title: "Sute de clienți, o singură recomandare",
      lead: "Părerea ta contează. Recenzii reale, verificate Google.",
      ratingLabel: "din 5 stele",
      countLabel: "recenzii Google",
      ctaWrite: "Scrie o recenzie",
      ctaAll: "Vezi toate recenziile",
      mockNotice: "Demo — la producție va prelua live din Google Business Profile",
      items: [
        {
          name: "Andrei Popescu",
          date: "Acum 2 săptămâni",
          rating: 5,
          text:
            "Service de încredere. Am făcut ITP-ul la camion și totul a decurs rapid, intrare/ieșire separate. Recomand cu căldură!",
        },
        {
          name: "Maria Ionescu",
          date: "Acum 1 lună",
          rating: 5,
          text:
            "Mi-au înlocuit parbrizul prin Pilkington. Calitate impecabilă, preț corect și au lucrat direct cu asigurarea. Mulțumesc!",
        },
        {
          name: "Cristian Radu",
          date: "Acum 3 luni",
          rating: 5,
          text:
            "Am avut o lovitură de piatră. M-au programat în aceeași zi, reparație rapidă. Personal profesionist, comunicare clară.",
        },
        {
          name: "Elena Vasile",
          date: "Acum 4 luni",
          rating: 4,
          text:
            "Diagnoză computerizată corectă, mi-au identificat o problemă pe care alt service o ratase. Am așteptat puțin mai mult, dar a meritat.",
        },
        {
          name: "Marius Stoica",
          date: "Acum 5 luni",
          rating: 5,
          text:
            "Constatare daune făcută rapid, lucrăm cu Allianz. Birou dedicat în service, totul s-a rezolvat fără bătaie de cap.",
        },
        {
          name: "Ioana Dumitrescu",
          date: "Acum 6 luni",
          rating: 5,
          text:
            "Încărcare freon R1234YF la prețul promovat. Serioși, te respectă ca client. Voi reveni cu siguranță.",
        },
      ],
    },
    pilkingtonPage: {
      eyebrow: "Serviciu dedicat",
      title: "Parbrize Pilkington — înlocuire, montaj și reparație ciobitură în Slobozia",
      lead:
        "Selena Service este Pilkington Team Partner: înlocuire parbriz și geamuri auto, montaj profesionist conform procedurilor de siguranță și reparație lovitură de piatră acolo unde este tehnic permis.",
      secondary:
        "Dacă cauți «parbriz Pilkington», «înlocuire parbriz cu senzori», «chip repair» sau «montaj ADAS», îți evaluăm avaria și îți spunem dacă merită reparația punctuală sau înlocuirea completă — inclusiv variante pentru flote și dosare CASCO.",
      bookingCopy: {
        eyebrow: "Programare parbrize Pilkington",
        title: "Solicită evaluare parbriz sau geam auto",
        lead:
          "Formular pentru înlocuire parbriz / reparație ciobitură — confirmăm interval și pașii tehnici.",
      },
      heroImageAlt:
        "Montaj parbriz Pilkington și lucrări geamuri auto la Selena Service Slobozia, Team Partner",
      subtitle: "Ce primești în centrul nostru de parbrize",
      bullets: [
        "Evaluare rapidă a avariei și recomandare clară: reparație sau înlocuire completă.",
        "Montaj profesional cu materiale conforme și proceduri de siguranță pentru etanșare corectă.",
        "Suport pentru decontare directă în baza polițelor CASCO, în funcție de asigurator.",
        "Acoperire multimarcă pentru autoturisme și flote comerciale.",
      ],
      cardsSectionTitle: "Siguranță structurală și proces controlat la montaj",
      card1Title: "Parbriz — element de siguranță",
      card1Text:
        "Montaj corect pentru rol structural și pentru senzori/camere moderne — verificăm etanșarea și recomandările producătorului sticlei.",
      card2Title: "Etape tehnice trasate",
      card2Text:
        "De la pregătirea adezivilor și timpii de întărire la predarea mașinii — îți comunicăm ce să eviți în orele următoare după montaj.",
      chipRepairEyebrow: "Reparații punctuale",
      chipRepairText:
        "Reparăm și ciobituri/lovituri de piatră în parbriz, atunci când dimensiunea și poziția avariei permit intervenția în siguranță.",
      chipRepairImage: "/resources/pilkington-chip-repair-before-after.png",
      chipRepairImageAlt: "Reparație ciobitură parbriz - înainte și după",
      workGalleryEyebrow: "Exemple reale",
      workGalleryTitle: "Galerie lucrări parbrize",
      workGalleryImageAlt: "Lucrare parbriz Pilkington",
      faqTitle: "Întrebări frecvente: parbrize Pilkington și montaj",
      faq: [
        {
          q: "Reparați ciobiturile sau doar înlocuiți parbrizul?",
          a:
            "Depinde de poziție, diametru și impactul asupra câmpului vizual — după inspecție îți spunem dacă reparația este sigură și durabilă sau dacă recomandăm înlocuire.",
        },
        {
          q: "Ce înseamnă Pilkington Team Partner?",
          a:
            "Este statutul nostru în rețeaua națională Pilkington Centru de Parbrize — acces la produse și fluxuri de montaj agreate de producător.",
        },
        {
          q: "Lucrați cu CASCO pentru decontare?",
          a:
            "Da, unde polița și compania permit decontarea directă sau flux agreat — îți explicăm pașii în funcție de asigurator.",
        },
        {
          q: "Cât durează montajul unui parbriz?",
          a:
            "Variază după vehicul, tip de senzori și procedura adezivilor — îți dăm estimare după ce vedem mașina și tipul geamului.",
        },
      ],
      ctaPrimary: "Programează înlocuirea",
      ctaSecondary: "Sună acum",
      imageAlt: "Centru de Parbrize Pilkington Team Partner",
    },
    booking: {
      eyebrow: "05 — Programare",
      title: "Programează-te în 30 de secunde",
      lead:
        "Lasă-ne datele tale și te sunăm înapoi pentru a confirma intervalul orar. Pentru urgențe, sună direct.",
      labels: {
        name: "Nume complet",
        email: "Email",
        phone: "Telefon",
        car: "Marcă & Model",
        service: "Serviciu dorit",
        date: "Data preferată",
        message: "Detalii suplimentare (opțional)",
      },
      placeholders: {
        name: "Ion Popescu",
        email: "ion.popescu@email.com",
        phone: "+40 7xx xxx xxx",
        car: "Volkswagen Golf 7",
        service: "Alege serviciul",
        message: "Ex: zgomot la frânare, schimb ulei + filtre...",
      },
      submit: "Trimite cererea",
      success:
        "Mulțumim! Cererea a fost înregistrată. Te vom contacta în cel mai scurt timp.",
      successEmailNotifyFailed:
        "Cererea a fost salvată, dar notificarea automată prin email nu a putut fi trimisă. Te vom contacta totuși după datele tale — sau sună-ne direct.",
      attachmentSkippedDbTitle: "Fișierul atașat nu a fost salvat",
      attachmentSkippedDbBody:
        "În baza de date lipsește coloana pentru documente (programarea totuși a fost înregistrată). Administratorul rulează migrarea din `database/sql/migrations/011_schema_bookings_talon_attachment.sql` (sau echivalent Docker init), apoi atașamentele vor funcționa.",
      validation: "Te rugăm să completezi numele, emailul, telefonul și serviciul.",
      phoneValidation: "Telefon invalid. Folosește doar cifre și simboluri telefonice (+, -, spațiu, paranteze).",
      submitErrorDefault:
        "Nu am putut trimite programarea acum. Încearcă din nou sau sună-ne direct.",
      recaptchaTitle: "Protecție anti-spam (Google reCAPTCHA)",
      recaptchaBody:
        "Nu vei vedea o bifă sau imagini — verificarea este invizibilă și rulează automat când apeși „Trimite cererea”. Dacă apare o eroare la verificare, reîncarcă pagina și încearcă din nou.",
      recaptchaLegalLead: "Anti-abuz:",
      recaptchaPrivacy: "Confidențialitate · Google",
      recaptchaTerms: "Termeni · Google",
      recaptchaLocalhostHint:
        "reCAPTCHA pe localhost: în Google Admin (cheia site folosită aici), la „Domenii” adaugă localhost și 127.0.0.1 — sau folosește cheile de test Google pentru dev.",
      talonLabel: "Document sau fotografie pentru cerere (opțional)",
      talonHint:
        "Poate fi talon, carte de identitate, foto cu mașina (ex. avarie), parbriz, acte etc. — PDF max. 5 MB; pozele pot fi mari pe telefon (până la ~28 MB), iar JPG/PNG/WebP sunt compactate automat la trimitere. Formate: JPEG, PNG, WebP sau PDF.",
      talonBrowse: "Alege fișier sau fă fotografie…",
      talonClear: "Elimină fișier",
      talonCaptureNote: "(pe mobil: permite acces la cameră dacă browserul îl cere)",
      talonErrSize: "Fișierul este prea mare după procesare sau PDF peste limită (maxim 5 MB).",
      talonErrSizeCamera:
        "Fișierul imagine este peste ~28 MB. Alege o poză mai mică din galerie sau o rezoluție medie înainte de trimitere.",
      talonErrType:
        "Format neacceptat. Folosiți doar JPG, PNG, WebP sau PDF.",
    },
    contact: {
      eyebrow: "05 — Contact",
      title: "Vino la atelier sau sună-ne",
      service: "Service Auto",
      serviceMobile: "Service Auto · Mobil",
      itp: "ITP & Tahograf",
      address: "Slobozia, Str. General Magheru nr. 73, jud. Ialomița",
      hours: "Luni – Vineri: 08:00 – 17:00",
      closed: "Sâmbătă & Duminică: Închis",
      hoursLabel: "Program",
      addressLabel: "Adresă",
      mapNote: "Hartă Google Maps — clic pe marker pentru indicații rută.",
      openInMaps: "Deschide în Google Maps",
    },
    whatsappFloat: {
      popupEyebrow: "WhatsApp · Selena Service",
      title: "Programare rapidă",
      body: "Răspundem în câteva minute, Lu–Vi 08:00–17:00.",
      openChip: "Scrie pe WhatsApp",
      presetMessage:
        "Bună ziua! Sunt interesat(ă) de o programare la Selena Service.",
      closeAria: "Închide",
      toggleAria: "WhatsApp",
    },
    termsPage: termsPageTranslations.ro,
    footer: {
      tagline:
        "Service auto multimarcă în Slobozia, Ialomița. Din 2014, lângă tine.",
      copyright: "© Selena Service, 2014–2026. Toate drepturile rezervate.",
      anpc: "ANPC — SAL",
      sol: "Soluționare Online a Litigiilor",
      cookieSettings: "Setări cookie-uri",
      terms: "Termeni și Condiții",
    },
    cookies: {
      title: "Acest site folosește cookie-uri",
      lead:
        "Folosim cookie-uri pentru a îmbunătăți experiența ta, a analiza traficul și a personaliza conținutul. Poți accepta toate, refuza toate sau alege ce categorii activezi.",
      acceptAll: "Acceptă toate",
      rejectAll: "Respinge toate",
      settings: "Setări",
      save: "Salvează preferințele",
      details: "Detalii",
      backLink: "Înapoi",
      categories: {
        necessary: {
          title: "Strict necesare",
          desc:
            "Cookie-urile esențiale pentru funcționarea site-ului (sesiune, securitate, preferință de limbă). Nu pot fi dezactivate.",
          required: "Obligatorii",
        },
        analytics: {
          title: "Statistică & performanță",
          desc:
            "Ne ajută să înțelegem cum este utilizat site-ul (Google Analytics, Plausible). Datele sunt agregate și anonime.",
        },
        marketing: {
          title: "Marketing & remarketing",
          desc:
            "Permit afișarea de reclame relevante pe alte site-uri (Meta Pixel, Google Ads). Necesită consimțământul tău explicit.",
        },
      },
      legal:
        "Conform GDPR și Directivei ePrivacy. Îți poți retrage consimțământul oricând din butonul „Setări cookie-uri” din subsol.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      whyUs: "Why us",
      rcaPartners: "Damage assessments",
      brands: "Brands",
      paint: "Paint",
      pilkington: "Windshields",
      climate: "Air conditioning",
      claims: "Damage repairs",
      oils: "Oils",
      mechanics: "Mechanics",
      diagnostics: "Diagnostics",
      itp: "PTI",
      tachograph: "Tachograph",
      booking: "Booking",
      contact: "Contact",
      bookNow: "Book now",
      serviceSwitcherAria: "Quick navigation between services",
      servicePrevAria: "Previous service",
      serviceNextAria: "Next service",
      breadcrumbAria: "Breadcrumb navigation",
      vinParts: "Parts by VIN",
    },
    vinPartsPage: {
      title: "Find parts by VIN",
      subtitle:
        "Enter a full 17-character VIN for most brands — indicative identification via NHTSA vPIC (US). For BMW you can also use the last 7 characters for RealOEM links and BavAUTO search by OE code. No account; prices are not shown.",
      vinLabel: "VIN or last 7 characters",
      vinPlaceholder: "e.g. WBADT43452G123456 or last 7",
      searchBtn: "Look up vehicle",
      disclaimer:
        "Information is indicative only. Always verify part compatibility before ordering.",
      recaptchaNotice: "Anti-abuse:",
      recaptchaPrivacy: "Google Privacy",
      recaptchaTerms: "Google Terms",
      recaptchaLocalhostHint:
        "reCAPTCHA on localhost: in Google Admin for this site key, add localhost and 127.0.0.1 under Domains — or use Google’s test keys for development.",
      recaptchaInfoTitle: "Anti-spam protection (Google reCAPTCHA)",
      recaptchaInfoBody:
        "There is no checkbox or puzzle — verification runs invisibly when you look up a VIN or browse OEM code lists. If you see a verification error, reload the page and try again.",
      recaptchaLegalLead: "Anti-abuse:",
      categoriesTitle: "Part categories",
      partsTitle: "OEM codes",
      searchProducts: "Find products",
      productsTitle: "BavAUTO matches (no price)",
      loading: "Loading…",
      emptyParts: "No OEM codes found for this category. Try another category.",
      partsNhtsaNoCatalog:
        "Category lists come from RealOEM diagrams. For this vehicle we only have NHTSA data — there is no automated catalog session, so OEM codes cannot be extracted here. Open a catalog in your browser and look up your serial / vehicle; once you have an OEM number, you can use BavAUTO product search from this tool.",
      partsCatalogLinkRealoem: "RealOEM — BMW catalog (your serial)",
      partsCatalogLinkVpic: "NHTSA vPIC — official portal (US)",
      partsCatalogLinkEtk: "BavAUTO ETK — online catalog",
      emptyProducts: "No public catalog matches for this code.",
      errorGeneric: "Something went wrong. Please try again later.",
      back: "Back to search",
      vehicleHeading: "Identified vehicle",
      catBrakes: "Brakes",
      catFilters: "Filters",
      catSuspension: "Suspension",
      catEngine: "Engine",
      catCooling: "Cooling",
      catElectric: "Electrics",
      fieldVin: "VIN (last 7)",
      fieldVinFull: "Full VIN (17 characters)",
      fieldBrand: "Brand",
      fieldManufacturer: "Manufacturer",
      fieldModel: "Model",
      fieldChassis: "Chassis",
      fieldEngine: "Engine",
      fieldProd: "Production / catalog",
      fieldRecordId: "Record ID",
      fieldSavedAt: "Saved at",
      fieldEmptyValue: "—",
      vehicleDetailsSectionTitle: "All fields returned by the decode source",
      fieldSource: "Source",
      vehicleDecodeSourceLabel: "Automated identification",
      vehicleNhtsaName: "NHTSA vPIC",
      vehicleCatalogManualLabel: "OEM catalog with diagrams (manual)",
      vehicleNhtsaNote:
        "Displayed data is indicative (US market). It does not replace the manufacturer catalog for part fitment.",
      diagramLink: "Diagram",
    },
    notFound: {
      eyebrow: "404",
      title: "Page not found",
      lead:
        "This URL does not match any page on our website. Check the spelling or use the menu to browse our services.",
      pathLabel: "URL:",
      hint: "If something looks wrong, call us and we will guide you.",
      backHome: "Back to homepage",
      callUs: "Call us",
      homeHref: "/",
      phoneHref: "tel:+40343101131",
    },
    appPortal: {
      metaTitle: "Sign in · Admin or desk portal | Selena Service",
      metaDescription:
        "Choose the admin dashboard or the reception / workshop desk login (Selena Service team).",
      eyebrow: "Team access",
      title: "Where would you like to sign in?",
      subtitle: "Pick the portal you need — we open the login page for you.",
      adminBtn: "Administrator",
      adminHint: "Reports, settings, portal users",
      deskBtn: "Reception / workshop",
      deskHint: "Bookings, agenda, files",
      backSite: "Back to public website",
    },
    hero: {
      eyebrow: "Multi-brand auto service · Slobozia · Romania",
      title1: "Selena",
      title2: "Service",
      lead:
        "Multi-brand repair shop since 2014. Periodic inspection, mechanics, body shop, Pilkington windshields and insurance claims — turnkey solutions for every budget.",
      ctaPrimary: "Book now",
      ctaSecondary: "View services",
      stat1: "12+",
      stat1Label: "Years experience",
      stat2: "22",
      stat2Label: "Brands serviced",
      stat3: "10",
      stat3Label: "Insurance partners",
      stat4: "100%",
      stat4Label: "Modern equipment",
      photoBadge: "Multi-brand repair shop · Since 2014",
    },
    services: {
      eyebrow: "01 — Services",
      title: "Everything your car needs",
      detailsCta: "See details",
      subtitle:
        "From periodic technical inspection to complex bodywork. Modern equipment, original parts, full workmanship warranty.",
      items: [
        {
          code: "S/01",
          title: "Mechanics & service",
          desc:
            "Periodic service, maintenance, full mechanical repairs, multi-brand. OEM original and equivalent parts.",
        },
        {
          code: "S/02",
          title: "Computer diagnostics",
          desc:
            "Multi-brand diagnostics with latest-gen testers. We quickly pinpoint any electronic or mechanical fault.",
        },
        {
          code: "S/03",
          title: "Body shop & paint",
          desc:
            "Bodywork, in-cabin paint jobs, professional finishes. On-site insurance claims office.",
        },
        {
          code: "S/04",
          title: "Pilkington windshields",
          desc:
            "Member of Pilkington Windshield Center national network. Replacements and stone-chip repairs.",
        },
        {
          code: "S/05",
          title: "Air conditioning",
          desc:
            "Car A/C refrigerant refill (R134a / R1234yf), leak checks, pressures and diagnostics in Slobozia. Optional UV contrast dye.",
        },
        {
          code: "S/06",
          title: "Insurance claims",
          desc:
            "RCA insurance partners (ASF-authorized). Dedicated claims office in service.",
        },
        {
          code: "S/07",
          title: "Oils & advice",
          desc:
            "We help you pick the right oil. The most expensive is not always the best.",
        },
        {
          code: "S/08",
          title: "PTI Cars & Trucks",
          desc:
            "Brand-new PTI line, separate entry/exit, state-of-the-art equipment for cars and commercial trucks.",
        },
        {
          code: "S/09",
          title: "Tachograph check",
          desc:
            "Periodic check of digital tachographs for commercial fleets, RAR-authorized. Maximum 2-year interval.",
        },
      ],
    },
    mechanicsPage: {
      eyebrow: "Dedicated service",
      title: "Auto mechanics & periodic service in Slobozia — multi-brand",
      lead:
        "Scheduled maintenance and mechanical repairs for passenger cars and light commercial vehicles: engine, brakes, steering, suspension, driveline and auxiliary systems — transparent quotes before work.",
      secondary:
        "Typical searches like \"oil change\", \"brake pads\", \"timing belt kit\" or \"suspension noise\" start with inspection and correct specification parts. From our workshop in Slobozia we serve Ialomița county with OEM original or OEM-equivalent components.",
      heroImageAlt:
        "Mechanical repairs, periodic maintenance and multi-brand service at Selena Service Slobozia",
      cardsSectionTitle: "Maintenance, mechanical repairs and the right parts",
      card1Title: "Scheduled maintenance",
      card1Text:
        "Oil + filters where applicable, fluid checks and preventive replacements aligned with mileage — plus notes for upcoming visits.",
      card2Title: "Mechanical repairs end-to-end",
      card2Text:
        "Diagnostics-led fixes on brakes, steering, suspension, clutch & timing kits (where relevant), transmission and engine components.",
      card3Title: "Original or OEM-equivalent parts",
      card3Text:
        "We propose compliant parts with budget clarity — durability and manufacturer specs drive the recommendation.",
      faqTitle: "FAQ: workshop services & periodic maintenance",
      faq: [
        {
          q: "What does periodic maintenance usually include?",
          a:
            "It varies by brand and mileage but commonly covers oil & filters, fluid checks and worn-item inspections. We list labour and parts before starting.",
        },
        {
          q: "Do you use genuine parts?",
          a:
            "We offer genuine OEM parts or OEM-equivalent certified alternatives — we explain pros/cons per critical item.",
        },
        {
          q: "Can I book diagnostics before repairing?",
          a:
            "Yes — computer diagnostics or mechanical inspection first helps avoid unnecessary replacements.",
        },
        {
          q: "Where are you located?",
          a:
            "Selena Service, 73 General Magheru Street, Slobozia, Ialomița county — book via the website form.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book mechanics / maintenance",
        title: "Request mechanical repair or periodic service",
        lead:
          "Online booking for maintenance or mechanical repairs — we call back quickly with confirmation.",
      },
    },
    diagnosticsPage: {
      eyebrow: "Dedicated service",
      title: "Computer diagnostics — multi-brand workshop in Slobozia",
      lead:
        "Professional ECU scanning for trouble codes (DTC), live data and guided checks — ideal before replacing expensive sensors blindly.",
      secondary:
        "If your MIL/check-engine light is on, power feels flat or consumption spikes, diagnostics correlates ECU messages with real-world checks so we repair causes — not symptoms only.",
      heroImageAlt:
        "Computer diagnostics, ECU fault codes and live parameters at Selena Service Slobozia",
      cardsSectionTitle: "Scanning, interpretation and a repair roadmap",
      card1Title: "Codes & live parameters",
      card1Text:
        "We access relevant modules (engine, transmission, ABS/ESP where applicable) and review freeze-frame data when useful.",
      card2Title: "Codes tied to symptoms",
      card2Text:
        "A fault code alone rarely equals \"replace sensor\". We combine tester results with mechanical/electrical verification.",
      card3Title: "Prioritized recommendations",
      card3Text:
        "Safety-critical issues first, planned maintenance second — pricing discussed before proceeding.",
      faqTitle: "FAQ: automotive computer diagnostics",
      faq: [
        {
          q: "When do I need diagnostics?",
          a:
            "Useful for warning lamps, rough running, odd noises tied to electronics or before major repairs — saves guesswork.",
        },
        {
          q: "Does a scanner replace manual inspection?",
          a:
            "No — we always validate findings physically where appropriate.",
        },
        {
          q: "Do you cover multiple brands?",
          a:
            "Yes — multi-brand workflows; complexity varies by vehicle generation.",
        },
        {
          q: "How do I book?",
          a:
            "Use this page's booking form — diagnostics can be pre-selected.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book diagnostics",
        title: "Request ECU diagnostics appointment",
        lead:
          "Book scanner session & interpretation — quick callback with confirmation.",
      },
    },
    climatePage: {
      eyebrow: "Dedicated service",
      title: "Car A/C service & R134a / R1234yf refrigerant refill in Slobozia",
      lead:
        "We service automotive air conditioning for reliable cooling and demisting all year round. We only use approved automotive refrigerants — often called \"car freon\" — either R134a or R1234yf (R1234YF), matched to your vehicle build year and manufacturer labels.",
      secondary:
        "If cooling is weak, you smell odours in the cabin, or the compressor runs without effect, you may need an A/C recharge (refrigerant top-up), leak diagnosis or circuit cleaning. We check operating pressures, verify sealing where appropriate, and explain clearly whether a top-up, vacuum/recharge cycle, or repair is the right fix.",
      heroImageAlt:
        "Car air conditioning recharge with R134a and R1234yf refrigerant, leak checks at Selena Service Slobozia, Romania",
      cardsSectionTitle: "What our refrigerant & A/C service includes",
      card1Title: "Correct refrigerant type (R134a vs R1234yf)",
      card1Text:
        "No guesswork: we refill only with the refrigerant type your car requires — classic R134a systems or newer R1234yf (HFO) circuits — following OEM/service-port labelling.",
      card2Title: "Pressures, sealing and circuit health",
      card2Text:
        "We assess working pressures, compressor and condenser operation, and trace refrigerant loss. When needed we can use UV contrast dye to pinpoint small leaks before wasting refrigerant.",
      card3Title: "Transparent recommendations",
      card3Text:
        "You receive a clear diagnosis and pricing before work: maintenance, refrigerant refill, proper evacuation/recharge procedure, or repair (e.g. seals or components) — without unnecessary upsells.",
      faqTitle: "FAQ: car freon (refrigerant), R134a and R1234yf",
      faq: [
        {
          q: "What is a car A/C refrigerant recharge and when is it needed?",
          a:
            "A recharge (top-up) adds approved automotive refrigerant after assessing system condition. It is commonly needed when cooling fades, refrigerant leaks slowly over time, or after work on the A/C circuit. In Slobozia we always check pressures and sealing first, then recommend the correct procedure.",
        },
        {
          q: "What is the difference between R134a and R1234yf (R1234YF)?",
          a:
            "R134a has been widely used on older systems with specific service fittings. R1234yf is common on newer passenger cars with different environmental requirements. They are not interchangeable without proper engineering and OEM guidance — we use exactly what your vehicle calls for.",
        },
        {
          q: "Why not only \"add a little refrigerant\"?",
          a:
            "Repeated loss or incorrect charge can damage the compressor and hide leaks at hoses, the condenser or seals. We combine charging with circuit checks — and leak tracing when needed — so you get lasting performance.",
        },
        {
          q: "Where are you located and how do I book?",
          a:
            "Selena Service is in Slobozia, Ialomița county. Use the booking form on this page for A/C service or refrigerant refill — we will confirm by phone.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book A/C / refrigerant service",
        title: "Request car A/C service or refrigerant refill",
        lead:
          "Book R134a / R1234yf A/C recharge or diagnostics — we call you back shortly to confirm your appointment.",
      },
    },
    oilsPage: {
      eyebrow: "Dedicated service",
      title: "Engine oil change & specification consulting — Slobozia",
      lead:
        "We guide you through choosing motor oil by manufacturer specification — SAE viscosity, API / ACEA categories and OEM approvals — without overspending.",
      secondary:
        "Before each oil service we verify quantity & grade and explain label basics plus dipstick checks between intervals. Official manufacturer selectors linked below help cross-check recommendations.",
      heroImageAlt:
        "Engine oil consulting, SAE/API/ACEA guidance and oil change service at Selena Service",
      standardsTitle: "Standards in the automotive oil industry",
      standardsLead:
        "The main standards used to select engine oil are defined by SAE, API and ACEA. They help you choose the right viscosity, performance level and engine compatibility.",
      standardsImageAlt: "SAE viscosity classification according to temperature range",
      apiImageAlt: "International API classification for diesel and gasoline engines",
      saeTitle: "SAE - Viscosity",
      saePoints: [
        "The first number (e.g. 5W) shows cold-temperature behavior; the lower it is, the easier the cold start.",
        "The letter W stands for winter and indicates low-temperature performance.",
        "The second number (e.g. 30, 40) shows high-temperature behavior and protection under heat.",
      ],
      apiTitle: "API - Performance level",
      apiPoints: [
        "For gasoline engines, classes start with S.",
        "For diesel engines, classes start with C.",
        "The second letter indicates performance generation; later letters generally mean newer standards.",
      ],
      aceaTitle: "ACEA - Application type",
      aceaPoints: [
        "A/B: gasoline and diesel passenger cars and light-duty vehicles.",
        "C: engines compatible with after-treatment systems (e.g. particulate filters).",
        "E: high-power diesel engines for commercial applications.",
      ],
      selectorTitle: "Oil identification - updated links",
      selectorLead:
        "Below are official selector tools from major brands, useful to identify the proper specification based on your vehicle and engine.",
      selectorLinks: [
        { name: "Castrol", url: "https://www.castrol.com/en_us/united-states/home/motor-oil-and-fluids/motor-oil-and-fluids-finder.html?customerType=retail" },
        { name: "Valvoline", url: "https://www.valvolineglobal.com/en/product-finder/" },
        { name: "Repsol", url: "https://lubricants.repsol.com/en/products/lubricants-search-engine/" },
        { name: "Mobil", url: "https://www.mobil.co.uk/en-gb/product-selector/" },
        { name: "LIQUI MOLY", url: "https://www.liqui-moly.com/en/us/service/oil-guide.html" },
      ],
      cardsSectionTitle: "Practical guidance before every oil service",
      card1Title: "Specs from manual / OEM sheets",
      card1Text:
        "We validate manufacturer-required viscosity & approvals — critical for turbocharged engines and diesel particulate filters.",
      card2Title: "Oil level discipline",
      card2Text:
        "Running low destroys bearings quickly — we show safe dipstick checks between visits.",
      card3Title: "Oil + filter together",
      card3Text:
        "Filters replaced together with oil when recommended — logged grade for service history.",
      faqTitle: "FAQ: motor oil & oil changes",
      faq: [
        {
          q: "How do I know which oil fits?",
          a:
            "Use handbook capacities page plus official selectors linked above — our technicians confirm final grade.",
        },
        {
          q: "What does 5W-30 mean?",
          a:
            "Cold-flow rating + hot viscosity behaviour — both must align with OEM tolerances.",
        },
        {
          q: "Mixing oils?",
          a:
            "Avoid mixing incompatible grades — emergency top-ups should match specification.",
        },
        {
          q: "Booking?",
          a:
            "Use \"Oils & consulting\" service form — callback confirmation.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book oil change",
        title: "Request oil consultation or oil + filter change",
        lead:
          "Leave details online — quick confirmation call.",
      },
    },
    paintPage: {
      eyebrow: "Dedicated service",
      title: "Car paint shop & body refinishing — booth curing in Slobozia",
      lead:
        "Professional refinishing for panels or targeted repairs — layered coatings for gloss retention and weather resistance.",
      leadExtended:
        "Vehicle preparation is performed in dedicated stations with filtered and dried air. Work-area masking is done thoroughly regardless of how many elements are painted, to avoid contamination and shade mismatch.",
      secondary:
        "Customers often search \"paint booth\", \"blend panel\", \"stone chip repair\". We inspect substrate damage first and propose booth curing timelines realistic for Romania's climate.",
      heroImageAlt: "Professional automotive paint booth refinishing at Selena Service",
      cardsSectionTitle: "Why filtered prep zones & booths matter",
      card1Title: "Prep & dedusting bays",
      card1Text:
        "Cleaning, sanding and masking boundaries minimize dirt inclusions that flash later under sunlight.",
      card2Title: "Masking & colour blend",
      card2Text:
        "Partial repairs rely on blending transitions — we explain achievable match vs aged OEM paint.",
      card3Title: "Controlled curing",
      card3Text:
        "Airflow & temperature schedules secure adhesion — safer polishing windows afterwards.",
      processTitle: "How we work in paint shop",
      processSteps: [
        "We assess surface condition and choose the right intervention: local, partial or full repaint.",
        "We prepare the surface through cleaning, sanding and proper masking of non-painted areas.",
        "Paint is applied in a dedicated booth with controlled airflow and temperature.",
        "Drying is controlled, followed by final quality checks and polishing when needed.",
      ],
      qualityTitle: "Materials & durability focus",
      qualityText:
        "Technical datasheets dictate flash times & reducer choice — adhesion & gloss longevity win over shortcuts.",
      faqTitle: "FAQ: automotive painting",
      faq: [
        {
          q: "Why a paint booth?",
          a:
            "Filtered intake air lowers contamination risk versus open-shop spraying.",
        },
        {
          q: "Spot repair invisible?",
          a:
            "Depends on paint age & metallics — inspection sets realistic outcome.",
        },
        {
          q: "Safe drive-away time?",
          a:
            "We advise cure windows before highway speeds / washes.",
        },
        {
          q: "Assessment booking?",
          a:
            "Use paint request form — photos help quoting.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book paint assessment",
        title: "Request body shop / paint evaluation",
        lead:
          "Online intake — callback with inspection slot.",
      },
    },
    itpPage: {
      eyebrow: "Dedicated service",
      title: "PTI / roadworthiness inspection — cars & trucks in Slobozia",
      lead:
        "Periodic Technical Inspection line with organised workflow — compliant checks for passenger cars and heavy goods vehicles.",
      secondary:
        "Booking online speeds scheduling — we'll confirm paperwork checklist per vehicle category.",
      heroImageAlt: "PTI lane for cars and commercial trucks — Selena Service Slobozia",
      cardsSectionTitle: "Legal checkpoints & smooth lane operation",
      card1Title: "Mandatory checkpoints",
      card1Text:
        "Inspection scope aligned with Romanian regulation per vehicle category.",
      card2Title: "Cars & commercial fleet",
      card2Text:
        "Dedicated bays sized for vans through heavier trucks — coordinated intake slots.",
      card3Title: "Scheduling clarity",
      card3Text:
        "Separate entry/exit routing lowers chaos on busy inspection days.",
      faqTitle: "FAQ: PTI appointments",
      faq: [
        {
          q: "Interval basics?",
          a:
            "Depends on vehicle category & usage — ask during confirmation call.",
        },
        {
          q: "Trucks supported?",
          a:
            "Yes — mention GVW class when booking.",
        },
        {
          q: "Documents?",
          a:
            "Typically registration & ID — we'll SMS specifics.",
        },
        {
          q: "Booking?",
          a:
            "Use PTI service form.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book PTI slot",
        title: "Request PTI appointment car/truck",
        lead:
          "Online request — callback confirmation.",
      },
    },
    tachographPage: {
      eyebrow: "Dedicated service",
      title: "Digital tachograph periodic verification — fleets & trucks",
      lead:
        "Periodic verification workflows for digital tachographs supporting compliant fleet operations.",
      secondary:
        "Fleet managers searching \"tachograph calibration\", \"due date tachograph\" can pre-book slots — we'll outline paperwork per vehicle.",
      cardsSectionTitle: "Technical verification & cadence reminders",
      card1Title: "Functional verification",
      card1Text:
        "Operational checks aligned with statutory tachograph obligations.",
      card2Title: "Deadline tracking",
      card2Text:
        "Reminder cadence to minimise downtime & penalties.",
      card3Title: "Fleet communication",
      card3Text:
        "Clear handover notes for transport office files.",
      faqTitle: "FAQ: tachograph checks",
      faq: [
        {
          q: "What is periodic tachograph verification?",
          a:
            "Regulated technical verification for installed digital tachographs on in-scope vehicles.",
        },
        {
          q: "Who should book?",
          a:
            "usually commercial road transport operators.",
        },
        {
          q: "Multiple trucks?",
          a:
            "Mention fleet size in booking message.",
        },
        {
          q: "Next step?",
          a:
            "Submit tachograph booking form.",
        },
      ],
      bookingCopy: {
        eyebrow: "Book tachograph",
        title: "Request tachograph verification slot",
        lead:
          "Online request — phone confirmation.",
      },
    },
    claimsPage: {
      eyebrow: "RCA damage desk",
      title: "Motor insurance damage assessment — on-site desk in Slobozia",
      tagline:
        "Had a collision and the other driver's RCA sits with one of our partner insurers? We've got you — we'll walk you through the steps.",
      lead:
        "Same workshop for paperwork and cars: we clarify notice & claim steps, tell you which documents to gather and keep communication tidy with the RCA carrier — then detailed inspection and body repair can continue right here.",
      secondary:
        "Fewer stops and fewer unknowns: one location for intake and for approved repair work.",
      cardsSectionTitle: "Claim clarity, insurer liaison & repair in one place",
      card1Title: "First step — notice & documents",
      card1Text:
        "We explain notice basics and tailor the checklist (registration cards, licences, RCA copies, European accident statement or police report where relevant). Photos plus visible mapping for the file.",
      card2Title: "Talking to the RCA insurer",
      card2Text:
        "We coordinate with ASF-listed RCA carriers shown below — we help you follow their submissions so typical procedural asks aren't missed.",
      card3Title: "Inspection & repair",
      card3Text:
        "Once the file is moving and labour is authorised, agreed inspectors and our teams continue inspection and bodywork under one roof.",
      faqTitle: "FAQ — RCA files & inspections",
      faq: [
        {
          q: "What does the initial desk visit cover?",
          a:
            "First-mile documentation after the crash — visible damage capture (photos), orientation on insurer steps and what their RCA desk expects next.",
        },
        {
          q: "Is there a physical desk on site?",
          a:
            "Yes — Selena Service hosts appointments for intake and guidance.",
        },
        {
          q: "Which insurers?",
          a:
            "ASF-authorised RCA partners listed below — confirm the tortfeasor's insurer appears there and ask us for insurer-specific nuances.",
        },
        {
          q: "Can I book online?",
          a:
            "Yes — use the claims intake form on this page and mention the RCA insurer if you already know it.",
        },
        {
          q: "Which documents are usually needed?",
          a:
            "Typically IDs & licences for drivers involved; vehicle docs (registration certificate & card); RCA policy copies; signed accident statement or police paperwork originals; scene photos; powers of attorney when someone else opens the file or for legal entities. Exact bundles vary — we'll tailor them during call or visit.",
        },
        {
          q: "How quickly should damage be notified?",
          a:
            "Notify promptly — often within the first 24–48 hours for minor collisions as best practice. Always cross-check your RCA policy wording and carrier guidance.",
        },
        {
          q: "What happens after the claim opens?",
          a:
            "The insurer follows its statutory timelines for review. Once labour is authorised we schedule detailed inspection and workshop entry.",
        },
      ],
      partnersTitle: "RCA insurance partners (ASF-authorized)",
      disclaimer:
        "Trade names and logos belong to their respective owners and are shown for identification only. We are not an official branch or representative of the listed insurers; our services complement — not replace — their contractual obligations.",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
      bookingCopy: {
        eyebrow: "Book claims intake",
        title: "Request damage assessment appointment",
        lead:
          "Online intake — insurer hints collected during callback.",
      },
    },
    why: {
      eyebrow: "02 — Why Selena",
      title: "Guarantee through deeds, not promises",
      lead:
        "We've been a multi-brand repair shop in Ialomița county since 2014. We work directly with manufacturers and insurers. Auditable quality, full transparency.",
      pilkington: {
        eyebrow: "Official partner",
        title: "Windshield Center - Pilkington Team Partner",
        lead:
          "Since August 2021, Selena Service has been part of the national Pilkington Windshield Center network for automotive glass replacement and fitting.",
        cta: "Open dedicated page",
        details: [
          "Pilkington Automotive Romania is a market leader with a nationwide windshield partner network.",
          "Windshields are structural safety components, so every intervention follows controlled quality and fitting standards.",
          "Direct claim settlement is available for CASCO policy holders, with dedicated support for fleets as well.",
        ],
        image: "/resources/pilkington-team-partner.png",
        imageAlt: "Pilkington Team Partner Windshield Center",
      },
      bullets: [
        "Authorized multi-brand repair shop",
        "Pilkington partner — Windshield Center",
        "State-of-the-art PTI equipment",
        "New facility, separate entry & exit",
        "On-premise insurance claims office",
        "Turnkey solutions for commercial fleets",
      ],
    },
    insurerPartnersHome: {
      eyebrow: "03 — Damage assessments",
      title: "RCA/CASCO damage assessments — ASF-listed partners, paperwork & repair on site",
      lead:
        "If the at-fault RCA sits with one of these insurers, we help after the crash with notices & paperwork orientation and with workshop repairs once authorised — our claims desk is inside Selena Service.",
      disclaimer:
        "Trade names and logos belong to their respective owners and are shown for identification only. We are not an official branch or representative of the listed insurers; our services complement — not replace — their contractual obligations.",
      cta: "Damage assessments & claims desk — details",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
    },
    brands: {
      eyebrow: "04 — Brands serviced",
      title: "We work with any brand",
    },
    reviews: {
      eyebrow: "Google Reviews",
      title: "Hundreds of customers, one recommendation",
      lead: "Your opinion matters. Real, Google-verified reviews.",
      ratingLabel: "out of 5 stars",
      countLabel: "Google reviews",
      ctaWrite: "Write a review",
      ctaAll: "See all reviews",
      mockNotice: "Demo — production will pull live from Google Business Profile",
      items: [
        {
          name: "Andrei Popescu",
          date: "2 weeks ago",
          rating: 5,
          text:
            "Reliable service. I did the truck PTI and everything went fast, separate entry/exit. Highly recommend!",
        },
        {
          name: "Maria Ionescu",
          date: "1 month ago",
          rating: 5,
          text:
            "They replaced my windshield through Pilkington. Impeccable quality, fair price, and they worked directly with insurance. Thank you!",
        },
        {
          name: "Cristian Radu",
          date: "3 months ago",
          rating: 5,
          text:
            "I had a stone chip. They scheduled me the same day, quick repair. Professional staff, clear communication.",
        },
        {
          name: "Elena Vasile",
          date: "4 months ago",
          rating: 4,
          text:
            "Accurate computer diagnostics, they identified a problem another shop missed. Waited a bit longer, but worth it.",
        },
        {
          name: "Marius Stoica",
          date: "5 months ago",
          rating: 5,
          text:
            "Fast claims handling, they work with Allianz. Dedicated office in the shop, everything resolved hassle-free.",
        },
        {
          name: "Ioana Dumitrescu",
          date: "6 months ago",
          rating: 5,
          text:
            "R1234YF refrigerant refill at the promo price. Serious, respectful. I'll definitely be back.",
        },
      ],
    },
    pilkingtonPage: {
      eyebrow: "Dedicated service",
      title: "Pilkington windshields — replacement, ADAS-safe fitting & chip repair",
      lead:
        "Official Pilkington Team Partner workshop: windshield & side glass replacement, structural adhesive curing best practices and chip repair where safe.",
      secondary:
        "ADAS camera recalibration topics, fleet glass programs and CASCO direct-billing pathways can be discussed case-by-case after inspection.",
      bookingCopy: {
        eyebrow: "Book windshield service",
        title: "Request windshield / glass evaluation",
        lead:
          "Form submission — we'll call with slot & prep steps.",
      },
      heroImageAlt: "Pilkington windshield replacement and chip repair Selena Service",
      subtitle: "What you get in our windshield center",
      bullets: [
        "Fast damage assessment and clear recommendation: repair or full replacement.",
        "Professional fitting with compliant materials and safety procedures for proper sealing.",
        "Support for direct claim settlement under CASCO policies, depending on your insurer.",
        "Multi-brand coverage for private vehicles and commercial fleets.",
      ],
      cardsSectionTitle: "Structural safety & controlled fitting process",
      card1Title: "Windshield structural role",
      card1Text:
        "Correct bonding supports cabin integrity and sensor mounting tolerances.",
      card2Title: "Process discipline",
      card2Text:
        "Primer/adhesive open times + safe drive-away guidance after install.",
      chipRepairEyebrow: "Targeted repairs",
      chipRepairText:
        "We also repair stone chips on windshields when the damage size and position allow a safe intervention.",
      chipRepairImage: "/resources/pilkington-chip-repair-before-after.png",
      chipRepairImageAlt: "Windshield chip repair - before and after",
      workGalleryEyebrow: "Real examples",
      workGalleryTitle: "Windshield work gallery",
      workGalleryImageAlt: "Pilkington windshield work",
      faqTitle: "FAQ: Pilkington glass services",
      faq: [
        {
          q: "Chip or full replacement?",
          a:
            "Function of size, cracks & driver's visual field — inspection decides.",
        },
        {
          q: "Team Partner meaning?",
          a:
            "National Pilkington Windshield Center network compliance path.",
        },
        {
          q: "CASCO billing?",
          a:
            "Case-by-case per policy direct settlement rules.",
        },
        {
          q: "Job duration?",
          a:
            "Vehicle & sensor dependent — quoted after VIN/glass scan.",
        },
      ],
      ctaPrimary: "Book windshield service",
      ctaSecondary: "Call now",
      imageAlt: "Pilkington Team Partner Windshield Center",
    },
    booking: {
      eyebrow: "05 — Booking",
      title: "Book in under 30 seconds",
      lead:
        "Leave us your details and we'll call you back to confirm a time slot. For emergencies, please call directly.",
      labels: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        car: "Make & model",
        service: "Desired service",
        date: "Preferred date",
        message: "Additional notes (optional)",
      },
      placeholders: {
        name: "John Doe",
        email: "john.doe@email.com",
        phone: "+40 7xx xxx xxx",
        car: "Volkswagen Golf 7",
        service: "Choose service",
        message: "Ex: brake noise, oil + filters change...",
      },
      submit: "Send request",
      success:
        "Thank you! Your request was registered. We'll contact you shortly.",
      successEmailNotifyFailed:
        "Your request was saved, but we couldn't send the automatic email notification. We'll still contact you using the details you provided — or call us directly.",
      attachmentSkippedDbTitle: "Your attached file was not stored",
      attachmentSkippedDbBody:
        "The database is missing the attachment column (your request was still saved). An admin should run `database/sql/migrations/011_schema_bookings_talon_attachment.sql` (or the Docker init migration), then uploads will work.",
      validation: "Please fill in name, email, phone and service.",
      phoneValidation: "Invalid phone. Use only digits and phone symbols (+, -, spaces, parentheses).",
      submitErrorDefault:
        "We couldn't send your request right now. Please try again or call us directly.",
      recaptchaTitle: "Anti-spam protection (Google reCAPTCHA)",
      recaptchaBody:
        "There is no checkbox or puzzle — verification runs invisibly when you click “Send request”. If you see a verification error, reload the page and try again.",
      recaptchaLegalLead: "Anti-abuse:",
      recaptchaPrivacy: "Google Privacy",
      recaptchaTerms: "Google Terms",
      recaptchaLocalhostHint:
        "reCAPTCHA on localhost: in Google Admin for this site key, add localhost and 127.0.0.1 under Domains — or use Google’s test keys for development.",
      talonLabel: "Photo or document with your request (optional)",
      talonHint:
        "For example: registration slip, ID copy, damage photos, windshield picture. PDF max 5 MB; photos from the phone may be larger on disk (up to ~28 MB) — JPG/PNG/WebP are compressed automatically before upload. Formats: JPEG, PNG, WebP or PDF.",
      talonBrowse: "Choose file or take a photo…",
      talonClear: "Remove file",
      talonCaptureNote: "(on mobile your browser may ask for camera access)",
      talonErrSize: "File is still too large after processing or PDF exceeds the limit (5 MB max).",
      talonErrSizeCamera:
        "This image exceeds ~28 MB on disk. Choose a smaller photo from your gallery or use medium resolution.",
      talonErrType: "Unsupported format. Use JPG, PNG, WebP or PDF only.",
    },
    contact: {
      eyebrow: "05 — Contact",
      title: "Visit the shop or call us",
      service: "Auto service",
      serviceMobile: "Auto service · Mobile",
      itp: "PTI & Tachograph",
      address: "Slobozia, 73 General Magheru St., Ialomița County, Romania",
      hours: "Monday – Friday: 08:00 – 17:00",
      closed: "Saturday & Sunday: Closed",
      hoursLabel: "Hours",
      addressLabel: "Address",
      mapNote: "Google Maps — click the marker for directions.",
      openInMaps: "Open in Google Maps",
    },
    whatsappFloat: {
      popupEyebrow: "WhatsApp · Selena Service",
      title: "Quick booking",
      body: "We reply within minutes, Mon–Fri 08:00–17:00.",
      openChip: "Chat on WhatsApp",
      presetMessage: "Hello! I'd like to schedule an appointment at Selena Service.",
      closeAria: "Close",
      toggleAria: "WhatsApp",
    },
    termsPage: termsPageTranslations.en,
    footer: {
      tagline:
        "Multi-brand auto service in Slobozia, Romania. Since 2014, by your side.",
      copyright: "© Selena Service, 2014–2026. All rights reserved.",
      anpc: "ANPC — Alternative Dispute Resolution",
      sol: "Online Dispute Resolution",
      cookieSettings: "Cookie settings",
      terms: "Terms & Conditions",
    },
    cookies: {
      title: "This site uses cookies",
      lead:
        "We use cookies to improve your experience, analyze traffic and personalize content. You can accept all, reject all or choose which categories to enable.",
      acceptAll: "Accept all",
      rejectAll: "Reject all",
      settings: "Settings",
      save: "Save preferences",
      details: "Details",
      backLink: "Back",
      categories: {
        necessary: {
          title: "Strictly necessary",
          desc:
            "Essential cookies for site operation (session, security, language preference). Cannot be disabled.",
          required: "Required",
        },
        analytics: {
          title: "Analytics & performance",
          desc:
            "Help us understand how the site is used (Google Analytics, Plausible). Data is aggregated and anonymous.",
        },
        marketing: {
          title: "Marketing & retargeting",
          desc:
            "Allow showing relevant ads on other sites (Meta Pixel, Google Ads). Requires your explicit consent.",
        },
      },
      legal:
        "Compliant with GDPR and the ePrivacy Directive. You can withdraw your consent any time via the 'Cookie settings' button in the footer.",
    },
  },
  uk: {
    nav: {
      home: "Головна",
      services: "Послуги",
      whyUs: "Чому ми",
      rcaPartners: "Констатація збитків",
      brands: "Марки",
      paint: "Фарбування",
      pilkington: "Автоскло",
      climate: "Кондиціонер",
      claims: "Ремонт збитків",
      oils: "Оливи",
      mechanics: "Механіка",
      diagnostics: "Діагностика",
      itp: "ITP",
      tachograph: "Тахограф",
      booking: "Запис",
      contact: "Контакт",
      bookNow: "Записатися",
      serviceSwitcherAria: "Швидка навігація між послугами",
      servicePrevAria: "Попередня послуга",
      serviceNextAria: "Наступна послуга",
      breadcrumbAria: "Навігаційний шлях",
      vinParts: "Запчастини за VIN",
    },
    vinPartsPage: {
      title: "Підбір запчастин за VIN",
      subtitle:
        "Повний VIN (17 символів) — для більшості марок; орієнтовна ідентифікація через NHTSA vPIC (США). Для BMW можна також останні 7 символів — посилання RealOEM і пошук BavAUTO за кодом OE. Без акаунта; ціни не показуємо.",
      vinLabel: "VIN або останні 7 символів",
      vinPlaceholder: "напр. WBADT43452G123456 або останні 7",
      searchBtn: "Знайти авто",
      disclaimer:
        "Дані орієнтовні. Завжди перевіряйте сумісність запчастини перед замовленням.",
      recaptchaNotice: "Захист від зловживань:",
      recaptchaPrivacy: "Конфіденційність · Google",
      recaptchaTerms: "Умови · Google",
      recaptchaLocalhostHint:
        "reCAPTCHA на localhost: у Google Admin для цієї site key додайте localhost і 127.0.0.1 у розділі доменів — або використовуйте тестові ключі Google для розробки.",
      recaptchaInfoTitle: "Захист від спаму (Google reCAPTCHA)",
      recaptchaInfoBody:
        "Поле для галочки чи картинки не показується — перевірка невидима й запускається автоматично під час пошуку за VIN та перегляду списків кодів OEM. Якщо з’явиться помилка перевірки, оновіть сторінку й спробуйте ще раз.",
      recaptchaLegalLead: "Захист від зловживань:",
      categoriesTitle: "Категорії запчастин",
      partsTitle: "Коди OEM",
      searchProducts: "Шукати товари",
      productsTitle: "Результати BavAUTO (без ціни)",
      loading: "Завантаження…",
      emptyParts: "Не знайдено кодів для цієї категорії. Спробуйте іншу.",
      partsNhtsaNoCatalog:
        "Списки за категоріями беруться з діаграм RealOEM. Для цього авто є лише дані NHTSA — немає автоматичної сесії каталогу, тому коди OEM тут не витягуються. Відкрийте каталог у браузері за серійним номером / авто; коли буде код OEM, можна шукати товари BavAUTO з цього інструменту.",
      partsCatalogLinkRealoem: "RealOEM — каталог BMW (ваш серійний номер)",
      partsCatalogLinkVpic: "NHTSA vPIC — офіційний портал (США)",
      partsCatalogLinkEtk: "BavAUTO ETK — онлайн-каталог",
      emptyProducts: "Не знайдено публічних збігів для цього коду.",
      errorGeneric: "Сталася помилка. Спробуйте пізніше.",
      back: "Назад до пошуку",
      vehicleHeading: "Визначене авто",
      catBrakes: "Гальма",
      catFilters: "Фільтри",
      catSuspension: "Підвіска",
      catEngine: "Двигун",
      catCooling: "Охолодження",
      catElectric: "Електрика",
      fieldVin: "VIN (останні 7)",
      fieldVinFull: "Повний VIN (17 символів)",
      fieldBrand: "Марка",
      fieldManufacturer: "Виробник (Manufacturer)",
      fieldModel: "Модель",
      fieldChassis: "Кузов / серія",
      fieldEngine: "Двигун",
      fieldProd: "Дата / каталог",
      fieldRecordId: "ID запису",
      fieldSavedAt: "Збережено",
      fieldEmptyValue: "—",
      vehicleDetailsSectionTitle: "Усі поля з джерела декодування",
      fieldSource: "Джерело",
      vehicleDecodeSourceLabel: "Автоматична ідентифікація",
      vehicleNhtsaName: "NHTSA vPIC",
      vehicleCatalogManualLabel: "OEM-каталог з діаграмами (вручну)",
      vehicleNhtsaNote:
        "Дані орієнтовні (ринок США). Не замінюють каталог виробника для підбору запчастин.",
      diagramLink: "Діаграма",
    },
    notFound: {
      eyebrow: "404",
      title: "Сторінку не знайдено",
      lead:
        "Ця адреса не відповідає жодній доступній сторінці сайту. Перевірте написання або скористайтеся меню послуг.",
      pathLabel: "Адреса:",
      hint: "Якщо щось не так — зателефонуйте, ми допоможемо.",
      backHome: "На головну",
      callUs: "Зателефонувати",
      homeHref: "/",
      phoneHref: "tel:+40343101131",
    },
    appPortal: {
      metaTitle: "Вхід · Адмін або ресепшн | Selena Service",
      metaDescription:
        "Доступ до панелі адміністратора або порталу ресепшну та майстерні (команда Selena Service).",
      eyebrow: "Доступ команди",
      title: "Куди увійти?",
      subtitle: "Оберіть портал — відкриємо сторінку входу.",
      adminBtn: "Адміністратор",
      adminHint: "Звіти, налаштування, користувачі",
      deskBtn: "Ресепшн / майстерня",
      deskHint: "Записи, розклад, файли",
      backSite: "На публічний сайт",
    },
    hero: {
      eyebrow: "Мультимарковий автосервіс · Слобозія · Румунія",
      title1: "Selena",
      title2: "Service",
      lead:
        "Мультимарковий сервіс з 2014 року. Техогляд, механіка, кузовний ремонт, автоскло Pilkington та врегулювання збитків — комплексні рішення для будь-якого бюджету.",
      ctaPrimary: "Записатися зараз",
      ctaSecondary: "Переглянути послуги",
      stat1: "12+",
      stat1Label: "Років досвіду",
      stat2: "22",
      stat2Label: "Марок авто",
      stat3: "10",
      stat3Label: "Партнери-страховики",
      stat4: "100%",
      stat4Label: "Сучасне обладнання",
      photoBadge: "Мультимарковий сервіс · З 2014 року",
    },
    services: {
      eyebrow: "01 — Послуги",
      title: "Усе, що потрібно вашому авто",
      detailsCta: "Детальніше",
      subtitle:
        "Від періодичного техогляду до складного кузовного ремонту. Сучасне обладнання, оригінальні запчастини та гарантія на роботи.",
      items: [
        {
          code: "S/01",
          title: "Механіка та сервіс",
          desc:
            "Періодичне обслуговування, технічне утримання та повний механічний ремонт мультимаркових авто. Оригінальні та OEM-запчастини.",
        },
        {
          code: "S/02",
          title: "Комп'ютерна діагностика",
          desc:
            "Мультимаркова діагностика на сучасному обладнанні. Швидко виявляємо електронні та механічні несправності.",
        },
        {
          code: "S/03",
          title: "Кузовний ремонт і фарбування",
          desc:
            "Кузовні роботи, фарбування в камері та професійне фінішне покриття. Окремий офіс врегулювання збитків на території сервісу.",
        },
        {
          code: "S/04",
          title: "Автоскло Pilkington",
          desc:
            "Партнер національної мережі Pilkington Centru de Parbrize. Заміна скла та ремонт сколів від каміння.",
        },
        {
          code: "S/05",
          title: "Автокондиціонер",
          desc:
            "Заправка фреону R134a / R1234yf, перевірка герметичності та тисків, діагностика A/C у Слобозії. За потреби — УФ-контраст.",
        },
        {
          code: "S/06",
          title: "Врегулювання збитків",
          desc:
            "Партнери RCA (авторизовані ASF). Окремий офіс врегулювання збитків у сервісі.",
        },
        {
          code: "S/07",
          title: "Оливи та консультації",
          desc:
            "Допоможемо обрати правильну оливу. Найдорожча — не завжди найкраща.",
        },
        {
          code: "S/08",
          title: "ITP для авто та вантажівок",
          desc:
            "Нова лінія ITP, окремі в'їзд/виїзд, сучасне обладнання для легкових і комерційних авто.",
        },
        {
          code: "S/09",
          title: "Перевірка тахографа",
          desc:
            "Періодична перевірка цифрових тахографів для комерційних автопарків, авторизація RAR. Максимальний інтервал — 2 роки.",
        },
      ],
    },
    mechanicsPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Механіка та техобслуговування авто у Слобозії — мультимарка",
      lead:
        "Періодичне ТО та повний механічний ремонт для легкових і комерційних авто: двигун, гальма, рульова, підвіска, трансмісія — прозора згода перед роботами.",
      secondary:
        "Часті запити: «заміна масла», «гальмівні колодки», «ГРМ», «підвіска стукає». У Яломіці обслуговуємо з Слобозії з оригінальними або OEM-еквівалентами.",
      heroImageAlt:
        "Механічний ремонт і техобслуговування мультимарок у Selena Service Слобозія",
      cardsSectionTitle: "ТО, ремонт і правильні запчастини",
      card1Title: "Регламентне обслуговування",
      card1Text:
        "Масло й фільтри за регламентом, перевірка рідин і зношених вузлів — із чернеткою подальших робіт.",
      card2Title: "Механічний ремонт від А до Я",
      card2Text:
        "Гальма, підвіска, рульове, зчеплення, ГРМ (де доречно), трансмісія й двигун — спершу причина, потім заміна.",
      card3Title: "Оригінал або OEM",
      card3Text:
        "Допуски виробника й ваш бюджет — окремо по кожній критичній позиції.",
      faqTitle: "Часті запитання: сервіс і ТО авто",
      faq: [
        {
          q: "Що зазвичай входить у періодичне ТО?",
          a:
            "Залежить від пробігу й марки: масло/фільтри, перевірки вузлів. Перед стартом узгоджуємо список і вартість.",
        },
        {
          q: "Чи є оригінальні запчастини?",
          a:
            "Так — або сертифіковані OEM-аналоги з поясненням відмінностей.",
        },
        {
          q: "Спочатку діагностика?",
          a:
            "Можна записатися на діагностику перед дорогим ремонтом.",
        },
        {
          q: "Де ви знаходитесь?",
          a:
            "Слобозія, вул. Генерала Магеру 73, повіт Яломіца.",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на механіку / ТО",
        title: "Заявка на техобслуговування або ремонт",
        lead:
          "Форма на сайті — швидкий зворотний дзвінок із підтвердженням часу.",
      },
    },
    diagnosticsPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Комп'ютерна діагностика авто у Слобозії — мультимарка",
      lead:
        "Зчитування кодів DTC, параметри live та перевірки під сканером до дорогих замін датчиків.",
      secondary:
        "Якщо горить check engine чи є провали потужності — поєднуємо дані ЕБУ з реальною перевіркою на підйомнику.",
      heroImageAlt:
        "Діагностика ЕБУ та живих параметрів у Selena Service Слобозія",
      cardsSectionTitle: "Сканування, інтерпретація й план ремонту",
      card1Title: "Коди й параметри",
      card1Text:
        "Доступ до потрібних блоків і freeze-frame там, де це доречно.",
      card2Title: "Від коду до причини",
      card2Text:
        "Код помилки ≠ автоматично новий датчик — підтверджуємо фактами.",
      card3Title: "Пріоритети й орієнтовний бюджет",
      card3Text:
        "Спочатку безпека, потім планові роботи — усе узгоджуємо до оплати.",
      faqTitle: "Часті запитання: комп'ютерна діагностика",
      faq: [
        {
          q: "Коли потрібна діагностика?",
          a:
            "При індикаціях АБС/ESP/МІЛ, вібраціях чи перед великим ремонтом.",
        },
        {
          q: "Чи замінює сканер ручну перевірку?",
          a:
            "Ні — обидва етапи важливі.",
        },
        {
          q: "Чи підтримуєте різні марки?",
          a:
            "Так — мультимарковий підхід.",
        },
        {
          q: "Як записатися?",
          a:
            "Форма «Діагностика» на сайті.",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на діагностику ЕБУ",
        title: "Заявка на комп'ютерну діагностику",
        lead:
          "Онлайн-запис — передзвін із підтвердженням.",
      },
    },
    climatePage: {
      eyebrow: "Спеціалізована послуга",
      title: "Автокондиціонер та заправка фреону R134a / R1234yf у Слобозії",
      lead:
        "Сервіс автокондиціонера для стабільного охолодження та обігріву скла в будь-який сезон. Використовуємо лише затверджений автомобільний холодоагент (фреон для авто): R134a або R1234yf (R1234YF) — відповідно до року випуску та маркування вашого авто.",
      secondary:
        "Якщо слабко дме холодом, є запах у салоні або компресор працює без ефекту, можливо потрібна дозаправка фреону, пошук витоків або чищення системи. Перевіряємо робочі тиски, за потреби герметичність і пояснюємо прозоро: достатньо дозаправки, цикл відкачування/заправки чи потрібен ремонт.",
      heroImageAlt:
        "Заправка фреону R134a та R1234yf, перевірка автокондиціонера у Selena Service, Слобозія, Іаломіца",
      cardsSectionTitle: "Що входить у сервіс фреону та кондиціонера",
      card1Title: "Правильний тип фреону (R134a чи R1234yf)",
      card1Text:
        "Заправляємо лише тим холодоагентом, який передбачено для вашої машини: класичний R134a або новіші системи на R1234yf — за позначками виробника та сервісних портів.",
      card2Title: "Тиски, герметичність і стан контуру",
      card2Text:
        "Оцінюємо тиски, роботу компресора й конденсора та шукаємо втрати холодоагента. За потреби застосовуємо УФ-контраст для дрібних витоків.",
      card3Title: "Чіткі рекомендації до оплати",
      card3Text:
        "Отримуєте зрозумілий діагноз і орієнтовну вартість до робіт: обслуговування, заправка фреону, відкачування/заправка за процедурою або ремонт — без зайвих робіт.",
      faqTitle: "Часті запитання: фреон для авто, R134a та R1234yf",
      faq: [
        {
          q: "Що таке заправка фреону в автокондиціонер і коли вона потрібна?",
          a:
            "Дозаправка означає додавання затвердженого холодоагента після оцінки стану системи. Часто потрібна при слабкому охолодженні, повільній втраті холодоагента або після ремонту кондиціонера. У Слобозії ми спочатку перевіряємо тиски й герметичність, потім пропонуємо правильну процедуру.",
        },
        {
          q: "У чому різниця між R134a та R1234yf (R1234YF)?",
          a:
            "R134a довго використовувався на класичних установках із відповідними сервісними з'єднаннями. R1234yf поширений на новіших авто з іншими екологічними вимогами. Вони не взаємозамінні «на око» — ми використовуємо лише те, що передбачено для вашого авто.",
        },
        {
          q: "Чому недостатньо просто «трохи долити фреону»?",
          a:
            "Повторні втрати або неправильний рівень заважають компресору й маскують витоки на шлангах, радіаторі або ущільненнях. Ми поєднуємо заправку з перевіркою контуру й пошуком витоків за потреби.",
        },
        {
          q: "Де ви знаходитесь і як записатися?",
          a:
            "Selena Service у Слобозії, повіт Іаломіца. Заповніть форму запису на цій сторінці для сервісу кондиціонера чи заправки фреону — підтвердимо час по телефону.",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис: кондиціонер / фреон",
        title: "Заявка на заправку фреону або сервіс автокондиціонера",
        lead:
          "Залиште заявку на R134a / R1234yf або діагностику A/C — швидко передзвонимо для підтвердження запису.",
      },
    },
    oilsPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Заміна моторної оливи та консультація з допусків — Слобозія",
      lead:
        "Допомагаємо підібрати оливу за SAE/API/ACEA та OEM-допусками — без переплати за непотрібний клас.",
      secondary:
        "Контролюємо об'єм і допуск перед зливом; показуємо перевірку щупа між сервісами. Офіційні селектори брендів нижче для самоперевірки.",
      heroImageAlt:
        "Консультація з моторних олив і заміна масла Selena Service Слобозія",
      standardsTitle: "Стандарти в індустрії моторних олив",
      standardsLead:
        "Основні стандарти для вибору моторної оливи визначають SAE, API та ACEA. Вони допомагають правильно підібрати в'язкість, рівень продуктивності та сумісність з типом двигуна.",
      standardsImageAlt: "Класифікація в'язкості SAE залежно від температури",
      apiImageAlt: "Міжнародна класифікація API для дизельних і бензинових двигунів",
      saeTitle: "SAE - В'язкість",
      saePoints: [
        "Перше число (наприклад, 5W) показує поведінку на холоді; чим менше число, тим легший холодний запуск.",
        "Літера W означає winter (зима) і вказує на роботу оливи за низьких температур.",
        "Друге число (наприклад, 30, 40) показує поведінку при нагріванні та захист за високих температур.",
      ],
      apiTitle: "API - Рівень продуктивності",
      apiPoints: [
        "Для бензинових двигунів використовуються класи, що починаються з S.",
        "Для дизельних двигунів використовуються класи, що починаються з C.",
        "Друга літера показує покоління продуктивності; пізніша літера зазвичай означає новіший стандарт.",
      ],
      aceaTitle: "ACEA - Тип застосування",
      aceaPoints: [
        "A/B: бензинові та дизельні двигуни легкових і легких комерційних авто.",
        "C: двигуни, сумісні із системами доочистки (наприклад, фільтрами твердих частинок).",
        "E: потужні дизельні двигуни для комерційного застосування.",
      ],
      selectorTitle: "Підбір оливи - оновлені посилання",
      selectorLead:
        "Нижче офіційні селектори від провідних брендів для визначення правильної специфікації за авто та двигуном.",
      selectorLinks: [
        { name: "Castrol", url: "https://www.castrol.com/en_us/united-states/home/motor-oil-and-fluids/motor-oil-and-fluids-finder.html?customerType=retail" },
        { name: "Valvoline", url: "https://www.valvolineglobal.com/en/product-finder/" },
        { name: "Repsol", url: "https://lubricants.repsol.com/en/products/lubricants-search-engine/" },
        { name: "Mobil", url: "https://www.mobil.co.uk/en-gb/product-selector/" },
        { name: "LIQUI MOLY", url: "https://www.liqui-moly.com/en/us/service/oil-guide.html" },
      ],
      cardsSectionTitle: "Практичні поради перед заміною оливи",
      card1Title: "Допуски з щоденника й OEM",
      card1Text:
        "Не підміняємо клас оливи там, де критичні турбо або сажові фільтри.",
      card2Title: "Рівень на щупі",
      card2Text:
        "Низький рівень швидко руйнує вкладиші — навчаємо безпечній перевірці.",
      card3Title: "Олива + фільтр",
      card3Text:
        "Фільтр разом із маслом коли потрібно — записуємо клас для історії авто.",
      faqTitle: "Часті запитання: моторна олива",
      faq: [
        {
          q: "Як дізнатися допуск?",
          a:
            "Щоденник авто + офіційні селектори нижче — ми підтверджуємо у сервісі.",
        },
        {
          q: "Що означає 5W-30?",
          a:
            "Поведінка на холоді та при робочій температурі — обидва параметри задає виробник.",
        },
        {
          q: "Чи можна змішувати?",
          a:
            "Не рекомендуємо різні класи — екстрений долив лише того самого допуску.",
        },
        {
          q: "Як записатися?",
          a:
            "Форма «Оливи та консультації».",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на заміну оливи",
        title: "Заявка на консультацію або заміну масла й фільтра",
        lead:
          "Онлайн — передзвін для підтвердження.",
      },
    },
    paintPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Автофарбування й підготовка в камері — Слобозія",
      lead:
        "Фарбування елементів кузова та локальний ремонт лакофарбового покриття з контрольованою сушкою.",
      leadExtended:
        "Підготовка авто до фарбування виконується на спеціальних постах із фільтрацією та осушенням повітря. Робочі зони ізолюються повністю, незалежно від кількості елементів, щоб уникнути пилу та відмінностей відтінку.",
      secondary:
        "Часті теми: «фарбування після ДТП», «підфарбувати елемент», «рубінг». Оцінюємо підложку й озвучуємо реалістичний результат до старту.",
      heroImageAlt: "Фарбування авто у професійній камері Selena Service",
      cardsSectionTitle: "Чому важливі зони підготовки та камера",
      card1Title: "Підготовка й стримування пилу",
      card1Text:
        "Очищення, шліфування й маскування меж для рівномірного шару.",
      card2Title: "Змішування відтінку й blend",
      card2Text:
        "Часткові ремонти потребують коректних переходів — пояснюємо межі збігу з «старою» фарбою.",
      card3Title: "Контроль сушіння",
      card3Text:
        "Температура й час вирішують адгезію лаку та безпечну експлуатацію після видачі.",
      processTitle: "Як ми працюємо у фарбувальному цеху",
      processSteps: [
        "Оцінюємо стан поверхні та визначаємо тип робіт: локальне, часткове або повне фарбування.",
        "Готуємо поверхню: очищення, шліфування та правильне маскування зон, які не фарбуються.",
        "Наносимо фарбу в спеціальній камері з контролем повітряного потоку та температури.",
        "Сушіння проводиться контрольовано, після чого виконується фінальна перевірка та за потреби полірування.",
      ],
      qualityTitle: "Матеріали й довговічність покриття",
      qualityText:
        "Технічні листи задають час між шарами й тип розчинника — якість важливіша за прискорення.",
      faqTitle: "Часті запитання: автофарбування",
      faq: [
        {
          q: "Навіщо фарбувальна камера?",
          a:
            "Фільтроване повітря знижує ризик пор і включень.",
        },
        {
          q: "Чи буде не видно слідів?",
          a:
            "Залежить від віку ЛФП та типу металіку — кажемо чесно після огляду.",
        },
        {
          q: "Коли можна їхати?",
          a:
            "Дамо безпечний інтервал після полімеризації лаку.",
        },
        {
          q: "Як записатися?",
          a:
            "Форма на сторінці фарбування.",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на оцінку ЛФП",
        title: "Заявка на оцінку фарбувальних робіт",
        lead:
          "Онлайн — передзвін і запис на огляд.",
      },
    },
    itpPage: {
      eyebrow: "Спеціалізована послуга",
      title: "ITP для авто й вантажівок у Слобозії",
      lead:
        "Періодичний техогляд на сучасній лінії з окремими в'їздом і виїздом для легкових і комерційних авто.",
      secondary:
        "Онлайн-запис прискорює домовленість — підкажемо пакет документів під ваш клас авто.",
      heroImageAlt: "Лінія ITP для легкових і вантажівок Selena Service Слобозія",
      cardsSectionTitle: "Чіткий процес і відповідність нормам",
      card1Title: "Обов'язкові контрольні точки",
      card1Text:
        "Обсяг перевірки відповідає категорії ТЗ за чинними правилами.",
      card2Title: "Легкові та комерція",
      card2Text:
        "Обладнання під різну масу й габарити — домовляємося про час завантаженості.",
      card3Title: "Організація черги",
      card3Text:
        "Зрозумілий рух територією сервісу в день огляду.",
      faqTitle: "Часті запитання: ITP",
      faq: [
        {
          q: "Які терміни?",
          a:
            "Залежить від класу авто й режиму експлуатації — уточнюємо при дзвінку.",
        },
        {
          q: "Чи є вантажівки?",
          a:
            "Так — зазначте клас при записі.",
        },
        {
          q: "Документи?",
          a:
            "Типово техпаспорт і посвідчення — надішлемо список SMS.",
        },
        {
          q: "Як записатися?",
          a:
            "Форма «ITP».",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на ITP",
        title: "Заявка на проходження ITP авто чи вантажівки",
        lead:
          "Онлайн — підтвердження телефоном.",
      },
    },
    tachographPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Періодична перевірка цифрового тахографа — автопарки",
      lead:
        "Підтримуємо юридично необхідні перевірки тахографів для безперервності роботи перевізників.",
      secondary:
        "Записуйтеся онлайн для кількох машин — узгодимо документи для транспортного відділу.",
      cardsSectionTitle: "Технічний контроль і календар перевірок",
      card1Title: "Функціональний огляд",
      card1Text:
        "Відповідність алгоритму перевірки для вашого класу транспорту.",
      card2Title: "Нагадування про строки",
      card2Text:
        "Допомагаємо не пропускати межі й простої.",
      card3Title: "Звіт для офісу",
      card3Text:
        "Стисло по результатах для вашої транспортної служби.",
      faqTitle: "Часті запитання: тахограф",
      faq: [
        {
          q: "Що таке періодична перевірка?",
          a:
            "Регламентований технічний контроль встановленого цифрового тахографа.",
        },
        {
          q: "Хто записується?",
          a:
            "Зазвичай перевізники й власники автопарків.",
        },
        {
          q: "Кілька авто?",
          a:
            "Вкажіть кількість у повідомленні форми.",
        },
        {
          q: "Як почати?",
          a:
            "Форма «Тахограф».",
        },
      ],
      bookingCopy: {
        eyebrow: "Запис на тахограф",
        title: "Заявка на перевірку тахографа",
        lead:
          "Онлайн — підтвердження дзвінком.",
      },
    },
    claimsPage: {
      eyebrow: "Стіл прийому RCA",
      title: "Оцінка збитків RCA/CASCO — офіс у сервісі Слобозія",
      tagline:
        "ДТП і RCA винуватця оформлено в компанії з нашого списку? Допоможемо пройти кроки без зайвого стресу.",
      lead:
        "На базі сервісу пояснюємо повідомлення про збиток і збір документів, тримаємо звʼязок із RCA-страховиком — далі детальний огляд і кузовний ремонт можуть тривати тут же.",
      secondary:
        "Менше точок контакту: той самий сервіс для прийому інформації та для робіт після узгоджень.",
      cardsSectionTitle: "Документи, страховик і ремонт в одному місці",
      card1Title: "Крок 1 — повідомлення й документи",
      card1Text:
        "Чекліст документів (посвідчення, техпаспорт, копії RCA, європротокол або матеріали поліції тощо), фото та опис видимих пошкоджень.",
      card2Title: "Звʼязок із RCA-страховиком",
      card2Text:
        "ASF-партнери зі списку нижче — допомагаємо не пропустити їхні типові вимоги до справи.",
      card3Title: "Оцінка й ремонт",
      card3Text:
        "Після авторизації робіт узгоджений огляд і кузовні роботи продовжуються на базі сервісу.",
      faqTitle: "Часті запитання — RCA та огляди",
      faq: [
        {
          q: "Що включає первинний прийом у сервісі?",
          a:
            "Фіксація пошкоджень (фото), орієнтація щодо наступних кроків для RCA-досьє.",
        },
        {
          q: "Чи є офіс у сервісі?",
          a:
            "Так — Selena Service.",
        },
        {
          q: "Які страхові?",
          a:
            "Партнери RCA ASF у списку нижче.",
        },
        {
          q: "Як записатися?",
          a:
            "Форма «Збитки» на цій сторінці.",
        },
        {
          q: "Які документи зазвичай потрібні?",
          a:
            "Зазвичай: документи водіїв і авто; копії полісів RCA; оригінал європротоколу або матеріалів поліції; фото з місця; довіреності для юросіб або якщо відкриває інша особа. Точний перелік уточнюємо індивідуально.",
        },
        {
          q: "Як швидко повідомляти про збиток?",
          a:
            "Якомога швидше; часто орієнтир 24–48 годин для незначних ДТП. Перевіряйте умови поліса RCA та інструкції страховика.",
        },
        {
          q: "Що далі після відкриття справи?",
          a:
            "Страховик проходить свої строки розгляду. Після авторизації робіт плануємо детальний огляд і ремонт.",
        },
      ],
      partnersTitle: "Партнери RCA (авторизовані ASF)",
      disclaimer:
        "Комерційні назви та логотипи належать відповідним компаніям і показані для ідентифікації. Ми не є офіційним представництвом перелічених страховиків; наші послуги доповнюють, але не замінюють їхні зобовʼязання.",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
      bookingCopy: {
        eyebrow: "Запис у бюро збитків",
        title: "Заявка на первинну оцінку збитку",
        lead:
          "Онлайн — передзвін із переліком документів.",
      },
    },
    why: {
      eyebrow: "02 — Чому Selena",
      title: "Гарантія справою, а не словами",
      lead:
        "З 2014 року ми працюємо як мультимарковий сервіс у повіті Яломіца. Прозорість, контроль якості та сучасні стандарти.",
      pilkington: {
        eyebrow: "Офіційний партнер",
        title: "Центр автоскла — Pilkington Team Partner",
        lead:
          "Selena Service є частиною національної мережі Pilkington з монтажу та заміни автоскла.",
        cta: "Відкрити сторінку",
        details: [
          "Pilkington Automotive Romania — один із лідерів ринку з національною партнерською мережею центрів автоскла.",
          "Лобове скло є елементом безпеки кузова, тому всі роботи виконуються за контрольованими стандартами якості.",
          "Для клієнтів із CASCO доступне пряме врегулювання, також надається підтримка корпоративним автопаркам.",
        ],
        image: "/resources/pilkington-team-partner.png",
        imageAlt: "Центр автоскла Pilkington Team Partner",
      },
      bullets: [
        "Авторизований мультимарковий сервіс",
        "Партнер Pilkington — Центр автоскла",
        "Сучасне обладнання для ITP",
        "Нова база з окремими в'їздом і виїздом",
        "Офіс врегулювання збитків на території",
        "Комплексні рішення для комерційних автопарків",
      ],
    },
    insurerPartnersHome: {
      eyebrow: "03 — Констатація збитків",
      title: "Оцінка збитку RCA/CASCO — партнери ASF, документи й ремонт в одному місці",
      lead:
        "Якщо RCA винуватця оформлено у одного з цих страховиків, допоможемо з першими кроками після ДТП та з ремонтом після узгоджень — бюро збитків працює всередині Selena Service.",
      disclaimer:
        "Комерційні назви та логотипи належать відповідним компаніям і показані для ідентифікації. Ми не є офіційним представництвом перелічених страховиків; наші послуги доповнюють, але не замінюють їхні зобовʼязання.",
      cta: "Докладніше: констатація збитків і бюро",
      partners: [
        { name: "Allianz-Țiriac", url: "https://www.allianztiriac.ro" },
        { name: "Asirom VIG", url: "https://www.asirom.ro" },
        { name: "Axeria IARD", url: "https://www.axeria-iard.ro/" },
        { name: "DallBogg", url: "https://dallbogg.com/ro/" },
        { name: "Eazy Asigurări", url: "https://www.eazyinsure.ro/" },
        { name: "Generali România", url: "https://www.generali.ro" },
        { name: "Grawe România", url: "https://www.grawe.ro" },
        { name: "Groupama", url: "https://www.groupama.ro" },
        { name: "Hellas Direct", url: "https://www.hellasdirect.ro/" },
        { name: "Omniasig VIG", url: "https://www.omniasig.ro" },
      ],
    },
    brands: {
      eyebrow: "04 — Обслуговувані марки",
      title: "Працюємо з будь-якою маркою",
    },
    reviews: {
      eyebrow: "Відгуки Google",
      title: "Сотні клієнтів, одна рекомендація",
      lead: "Ваша думка важлива. Реальні відгуки, підтверджені Google.",
      ratingLabel: "із 5 зірок",
      countLabel: "відгуків Google",
      ctaWrite: "Написати відгук",
      ctaAll: "Переглянути всі відгуки",
      mockNotice: "Демо — у продакшені відгуки підтягуються з Google Business Profile",
      items: [
        {
          name: "Андрій Попеску",
          date: "2 тижні тому",
          rating: 5,
          text:
            "Надійний сервіс. Робив техогляд вантажівки — все швидко, окремий в'їзд і виїзд. Рекомендую!",
        },
        {
          name: "Марія Іонеску",
          date: "1 місяць тому",
          rating: 5,
          text:
            "Замінили лобове через Pilkington. Якість відмінна, чесна ціна, також допомогли зі страховкою.",
        },
        {
          name: "Крістіан Раду",
          date: "3 місяці тому",
          rating: 5,
          text:
            "Був скол від камінця. Записали в той же день, ремонт виконали швидко. Професійна команда і чітка комунікація.",
        },
        {
          name: "Олена Васіле",
          date: "4 місяці тому",
          rating: 4,
          text:
            "Діагностика була точною, знайшли проблему, яку в іншому сервісі пропустили. Довелося трохи почекати, але воно того варте.",
        },
        {
          name: "Маріус Стоїка",
          date: "5 місяців тому",
          rating: 5,
          text:
            "Врегулювання збитків пройшло швидко, працюють з Allianz. Все вирішили без зайвих клопотів.",
        },
        {
          name: "Йоана Думітреску",
          date: "6 місяців тому",
          rating: 5,
          text:
            "Заправка R1234YF за акційною ціною. Професійно та з повагою до клієнта. Обов'язково повернуся.",
        },
      ],
    },
    pilkingtonPage: {
      eyebrow: "Спеціалізована послуга",
      title: "Скло Pilkington — заміна, монтаж і ремонт сколу у Слобозії",
      lead:
        "Офіційний Pilkington Team Partner: заміна лобового та бокових стекол, клейовий монтаж за процедурою безпеки та ремонт сколу за технічною можливістю.",
      secondary:
        "Питання ADAS-камер, автопарків і прямого врегулювання CASCO обговорюємо після огляду.",
      bookingCopy: {
        eyebrow: "Запис на автоскло",
        title: "Заявка на оцінку скла / монтаж",
        lead:
          "Форма — передзвін із наступними кроками.",
      },
      heroImageAlt: "Заміна лобового Pilkington і ремонт сколу Selena Service",
      subtitle: "Що ви отримуєте в нашому центрі",
      bullets: [
        "Швидка оцінка пошкодження та чітка рекомендація: ремонт чи повна заміна.",
        "Професійний монтаж із сертифікованими матеріалами та дотриманням стандартів безпеки.",
        "Підтримка прямого врегулювання за полісами CASCO (залежно від страховика).",
        "Обслуговування приватних авто і комерційних автопарків.",
      ],
      cardsSectionTitle: "Структурна безпека й контрольований процес",
      card1Title: "Роль лобового скла",
      card1Text:
        "Коректний клей і витримка часу для міцності кузова й датчиків.",
      card2Title: "Технічний регламент",
      card2Text:
        "Грунтовка/адгезиви й безпечне використання авто після видачі.",
      chipRepairEyebrow: "Точковий ремонт",
      chipRepairText:
        "Ми також ремонтуємо сколи від камінців, якщо розмір і місце пошкодження дозволяють безпечне відновлення.",
      chipRepairImage: "/resources/pilkington-chip-repair-before-after.png",
      chipRepairImageAlt: "Ремонт сколу лобового скла - до та після",
      workGalleryEyebrow: "Реальні приклади",
      workGalleryTitle: "Галерея робіт",
      workGalleryImageAlt: "Робота з автосклом Pilkington",
      faqTitle: "Часті запитання: Pilkington і монтаж",
      faq: [
        {
          q: "Ремонт чи заміна?",
          a:
            "Після огляду — з урахуванням зони видимості й тріщин.",
        },
        {
          q: "Що таке Team Partner?",
          a:
            "Статус у національній мережі Pilkington Centru de Parbrize.",
        },
        {
          q: "CASCO?",
          a:
            "За правилами полісу й компанії.",
        },
        {
          q: "Тривалість робіт?",
          a:
            "Залежить від авто й скла — скажемо після ідентифікації.",
        },
      ],
      ctaPrimary: "Записатися на послугу",
      ctaSecondary: "Подзвонити зараз",
      imageAlt: "Pilkington Team Partner",
    },
    booking: {
      eyebrow: "05 — Запис",
      title: "Запишіться за 30 секунд",
      lead:
        "Залиште ваші дані, і ми передзвонимо для підтвердження часу. Для термінових випадків телефонуйте напряму.",
      labels: {
        name: "ПІБ",
        email: "Email",
        phone: "Телефон",
        car: "Марка та модель",
        service: "Потрібна послуга",
        date: "Бажана дата",
        message: "Додатково (необов'язково)",
      },
      placeholders: {
        name: "Іван Петренко",
        email: "ivan.petrenko@email.com",
        phone: "+40 7xx xxx xxx",
        car: "Volkswagen Golf 7",
        service: "Оберіть послугу",
        message: "Наприклад: скрип при гальмуванні, заміна масла + фільтрів...",
      },
      submit: "Надіслати заявку",
      success: "Дякуємо! Заявку отримано. Ми зв'яжемося з вами найближчим часом.",
      successEmailNotifyFailed:
        "Заявку збережено, але автоматичне email-сповіщення не надіслано. Ми все одно зв'яжемося з вами за вказаними даними — або зателефонуйте нам.",
      attachmentSkippedDbTitle: "Прикріплений файл не збережено",
      attachmentSkippedDbBody:
        "У базі немає колонки для вкладень (заявку все одно збережено). Адміністратор має виконати `database/sql/migrations/011_schema_bookings_talon_attachment.sql` (або init у Docker), після чого завантаження файлів запрацюють.",
      validation: "Будь ласка, заповніть ім'я, email, телефон та послугу.",
      phoneValidation:
        "Невірний телефон. Використовуйте лише цифри та телефонні символи (+, -, пробіл, дужки).",
      submitErrorDefault:
        "Не вдалося надіслати заявку. Спробуйте ще раз або зателефонуйте нам.",
      recaptchaTitle: "Захист від спаму (Google reCAPTCHA)",
      recaptchaBody:
        "Поле для галочки чи картинки не показується — перевірка невидима й запускається автоматично під час відправки форми. Якщо з’явиться помилка перевірки, оновіть сторінку й спробуйте ще раз.",
      recaptchaLegalLead: "Захист від зловживань:",
      recaptchaPrivacy: "Конфіденційність · Google",
      recaptchaTerms: "Умови · Google",
      recaptchaLocalhostHint:
        "reCAPTCHA на localhost: у Google Admin для цієї site key додайте localhost і 127.0.0.1 у розділі доменів — або використовуйте тестові ключі Google для розробки.",
      talonLabel: "Фото або документ до заявки (за бажанням)",
      talonHint:
        "Наприклад: техпаспорт (талон), паспорт або ID, фото пошкоджень, скла тощо — PDF до 5 МБ; світлини на телефоні можуть бути до ~28 МБ у файлі, JPG/PNG/WebP стискаються автоматично перед надсиланням. Формати: JPEG, PNG, WebP або PDF.",
      talonBrowse: "Обрати файл або зробити фото…",
      talonClear: "Прибрати файл",
      talonCaptureNote: "(на мобільному браузер може запросити доступ до камери)",
      talonErrSize: "Файл занадто великий після обробки або PDF понад ліміт (макс. 5 МБ).",
      talonErrSizeCamera:
        "Зображення більше ~28 МБ. Оберіть менший файл із галереї або середню якість експорту.",
      talonErrType: "Формат не підтримується. Лише JPG, PNG, WebP або PDF.",
    },
    contact: {
      eyebrow: "05 — Контакт",
      title: "Завітайте до сервісу або зателефонуйте",
      service: "Автосервіс",
      serviceMobile: "Автосервіс · Мобільний",
      itp: "ITP & Тахограф",
      address: "Слобозія, вул. General Magheru 73, повіт Яломіца",
      hours: "Понеділок – П'ятниця: 08:00 – 17:00",
      closed: "Субота та Неділя: Зачинено",
      hoursLabel: "Графік",
      addressLabel: "Адреса",
      mapNote: "Google Maps — натисніть маркер для маршруту.",
      openInMaps: "Відкрити в Google Maps",
    },
    whatsappFloat: {
      popupEyebrow: "WhatsApp · Selena Service",
      title: "Швидкий запис",
      body: "Відповідаємо протягом кількох хвилин, Пн–Пт 08:00–17:00.",
      openChip: "Написати в WhatsApp",
      presetMessage:
        "Доброго дня! Хочу записатися в Selena Service.",
      closeAria: "Закрити",
      toggleAria: "WhatsApp",
    },
    termsPage: termsPageTranslations.uk,
    footer: {
      tagline: "Мультимарковий автосервіс у Слобозії. Працюємо з 2014 року.",
      copyright: "© Selena Service, 2014–2026. Усі права захищено.",
      anpc: "ANPC — Альтернативне вирішення спорів",
      sol: "Онлайн вирішення спорів",
      cookieSettings: "Налаштування cookie",
      terms: "Умови та конфіденційність",
    },
    cookies: {
      title: "Цей сайт використовує cookie",
      lead:
        "Ми використовуємо cookie для покращення досвіду, аналітики трафіку та персоналізації контенту. Ви можете прийняти всі, відхилити всі або обрати категорії.",
      acceptAll: "Прийняти все",
      rejectAll: "Відхилити все",
      settings: "Налаштування",
      save: "Зберегти",
      details: "Деталі",
      backLink: "Назад",
      categories: {
        necessary: {
          title: "Обов'язкові",
          desc:
            "Необхідні cookie для роботи сайту (сесія, безпека, мовні налаштування). Їх не можна вимкнути.",
          required: "Обов'язково",
        },
        analytics: {
          title: "Аналітика та продуктивність",
          desc:
            "Допомагають зрозуміти, як використовується сайт (Google Analytics, Plausible). Дані агреговані та анонімні.",
        },
        marketing: {
          title: "Маркетинг і ремаркетинг",
          desc:
            "Дозволяють показувати релевантну рекламу на інших сайтах (Meta Pixel, Google Ads). Потрібна явна згода.",
        },
      },
      legal:
        "Відповідно до GDPR та ePrivacy. Ви можете відкликати згоду будь-коли через налаштування cookie.",
    },
  },
};
